import React from 'react';
import { Alert ,Container, Col, Row, Button, FormGroup } from 'reactstrap';
import TextField from "material-ui/TextField";
import MenuItem from "material-ui/MenuItem";
import SelectField from "material-ui/SelectField";
import {RadioButton, RadioButtonGroup} from 'material-ui/RadioButton';
import {Table, TableBody, TableHeader, TableHeaderColumn, TableRow, TableRowColumn} from 'material-ui/Table';
import CircularProgress from 'material-ui/CircularProgress';
import Checkbox from 'material-ui/Checkbox';
import InputMask from 'react-input-mask';
import CurrencyInput from 'react-currency-input';
import Dialog from 'material-ui/Dialog';
import urlBase from '../../../url-base';
import axios from 'axios';
import readXlsxFile from 'read-excel-file';
import '../../../assets/css/required.css';
//import { strictEqual } from 'assert';
import {Colors, Styles} from '../../../../src/styles/theme';
import {Link} from 'react-router';


class RegisterCompany extends React.Component {

  constructor(props) {
    super(props);

    this.state = {
      stepForm: 1,

      typeOfContract: 'NC',
      tipoTributacao: '',
      amountUsers: '',

      addressTypeList: [],
      stateList: [],
      cityList: [],
      districtList: [],
      plansPjList: [],

      cnpj: '',
      openingDate: '',
      fantasyName: '',
      businessName: '',
      cep: '',
      state: '',
      addressType: '',
      address: '',
      addressComplement: '',
      city: '',
      district: '',
      addressNumber: 0,
      homePhone: '',
      cellPhone: '',
      cellPhone2: '',
      costCenter: '',

      legalResponsible: '',
      legalResponsibleRg: '',
      legalResponsibleCpf: '',
      legalResponsibleEmail: '',

      infoWorkerName: '',
      infoEmailContact: '',
      infoHomePhone: '',
      infoCellPhone: '',
      infoEmailInvoice: '',
      infoPersonInCharge: '',
      infoPersonInChargePhone: '',

      effectiveDate: '',
      effectiveDateMonth: '',
      monthlyExpiration: '',
      cuttingDay: '',
      chanelConfirm: 'EMAIL',

      effectiveDateYearList: [],
      salesmansId: '',
      listSalesman: [],
      listBroker: [],
      chooseSalesmanFlag: false,
      chooseBrokerFlag: false,
      chooseSalesmanSelect: 'null',
      chooseBrokerSelect: 'null',
      disabledSalesmanSelect: false,
      disabledBrokerSelect: false,

      amountUsersValueHolder: '',
      amountUsersValueDependent: '',
      amountUsersValueOrto: '',
      amountUsersValueHolderStr: '',
      amountUsersValueDependentStr: '',
      valuePlanDivergent: false,
      valuePlanOrtoDivergent: false,
      justifyValue: '',
      justifyValueOrto: '',
      amountUsersValueShow: '',
      checkPlanOrto: false,
      checkPlanOrtoValue: '',
      valorPlanOrtoFinal: '',
      valorPlanOrtoFinalStr: '',

      amountHolder: 0,
      amountDependent: 0,
      amountOrto: 0,
      modalErrorImages:false,

      imagesDocs: {
        usersTable: '',
        rg: '',
        cnh:'',
        rg2: '',
        cpf: '',
        cnpj: '',
        address: '',
        /*
        physicalContract1: '',
        physicalContract2: '',
        physicalContract3: '',
        */
        others: '',
      },
      documentType : 'rg', 
      imagesDocsUrl: {
        usersTable: '',
        rg: '',
        cnh: '',
        rg2: '',
        cpf: '',
        cnpj: '',
        address: '',
        physicalContract1: '',
        physicalContract2: '',
        physicalContract3: '',
        others: '',
      },

      usersTableExt: '',
      usersTableError: '',

      currentTimeServer: null,

      openTerms: false,
      resultValidateForm: [],

    };

    this.styles = {
      amountUsersValueTitle: {
        fontSize: 12,
        fontWeight: 500,
        margin: 0,
        textAlign: 'center',
      },
      floatingLabelStyle : {
        color: '#000000'
      },                      
      amountUsersValueHint: {
        fontSize: 11,
        color: '#ed4134',
        margin: 0,
        textAlign: 'center'
      },     
      amountUsersValueNumber: {
        fontSize: 30,
        textAlign: 'center',
        fontWeight: 500,
        paddingTop: 24,
      },
      amountUsersValueNumber2: {
        fontSize: 23,
        textAlign: 'center',
        fontWeight: 500,
        paddingTop: 23,
      },
    
    };
    // Campos obrigatórios primeira parte
    this.requiredFields = {
      cnpj: true, openingDate: true, fantasyName: true, businessName: true, cep: true, state: true,
      addressType: true, address: true, city: true, district: true, addressComplement: false,
      homePhone: false, cellPhone: true, cellPhone2: false, legalResponsible: true, addressNumber: true,
      legalResponsibleRg: true, legalResponsibleCpf: true, legalResponsibleEmail: false, infoWorkerName: false,
      infoEmailContact: true, infoHomePhone: false, infoCellPhone: true, infoEmailInvoice: true,
      infoPersonInCharge: true, infoPersonInChargePhone: false, typeOfContract: false, tipoTributacao : true,
      chanelConfirm: true,

    };

    this.requiredFields2 = {
      amountUsers: true, effectiveDate: true, effectiveDateMonth: true, monthlyExpiration: true, cuttingDay: true,
      amountUsersValueHolder: true, amountUsersValueDependent: true, amountHolder: true, amountDependent: true,
      amountOrto: true,
    };
    // Erros
    this.errorField = {
      cnpj: '', openingDate: '', fantasyName: '', businessName: '', cep: '', state: '',
      addressType: '', address: '', city: '', district: '', addressComplement: '',
      homePhone: '', cellPhone: '', cellPhone2: '', legalResponsible: '', addressNumber: '',
      legalResponsibleRg: '', legalResponsibleCpf: '', legalResponsibleEmail: '',
      infoWorkerName: '', infoEmailContact: '', infoHomePhone: '', infoCellPhone: '',
      infoEmailInvoice: '', infoPersonInCharge: '', infoPersonInChargePhone: '', typeOfContract: 'NC', tipoTributacao:'',
      amountUsers: '', effectiveDate: '', effectiveDateMonth: '', monthlyExpiration: '', cuttingDay: '',
      chanelConfirm: '', chooseSalesmanSelect: '', amountUsersValueHolder: '', amountUsersValueDependent: '',
      justifyValue: '', justifyValueOrto: '', amountHolder: '', amountDependent: '', amountOrto: '', chooseBrokerSelect: ''
    };
  }


  handleErrorOpen() {
    let state = this.state;
    state.modalErrorImages = true;
    this.setState(state);
    return false;
  }
  handleErrorClose() {
    let state = this.state;
    state.modalErrorImages = false;
    this.setState(state);
  }
validateImages() {
  const { imagesDocs, documentType } = this.state;
  let result = true;

  // 1. Validação de Documentos Fixos (Sempre obrigatórios)
  if ( imagesDocs.cnpj === '') {
    result = false;
  }

  // 2. Validação Dinâmica (RG ou CNH)
  if (documentType === 'rg') {
    // Se for RG, exige Frente (rg) E Verso (rg2)
    if (imagesDocs.rg === '' || imagesDocs.rg2 === '' || imagesDocs.cpf === '') {
      result = false;
    }
  } else if (documentType === 'cnh') {
    // Se for CNH, exige apenas o arquivo principal (rg)
    if (imagesDocs.cnh === '') {
      result = false;
    }
  }

  // 3. Validação Opcional (Comprovante de endereço, se desejar tornar obrigatório)
  /*
  if (imagesDocs.address === '') {
    result = false;
  }
  */

  if (!result) {
    this.handleErrorOpen();
  }

  return result;
}
clearDocument(key) {
  this.setState(prevState => ({
    imagesDocs: {
      ...prevState.imagesDocs,
      [key]: ""
    },
    imagesDocsUrl: {
      ...prevState.imagesDocsUrl,
      [key]: ""
    }
  }));
}  
  /*
  validateImages(){
    let result = true;
    if (this.state.imagesDocs.rg==''){
      result = false;
    }
    if (this.state.imagesDocs.cpf == '') {      
      result = false;
    }    
    if (this.state.imagesDocs.cnpj == '') {      
      result = false;
    }

    if(!result){
      this.handleErrorOpen();
    }    
    
    return result;
    
  }
  */

  componentWillMount() {
    // Pega a lista de planosPJ
    axios.get(urlBase.loopBack + 'Plans?filter={"where":{"type":"PJ"}}')
    .then((result) => {
      let date = new Date();
      let state = this.state;

      // Anos para a data de vigência
      date = date.getFullYear();
      state.effectiveDateYearList.push(date);
      state.effectiveDateYearList.push(date+1);

      state.plansPjList = result.data;
      this.setState(state);

      this.getStates();// Pega a lista de estados
      this.getAddressType();// Pega a lista de tipos de endereço
      this.getSalesman();// Pega a lista de vendedores caso o usuário seja corretora ou backoffice
      this.getCurrentTimeServer();// Pega horário do servidor
    })
    .catch(function () {
      this.setError('Não conseguimos encontrar a lista com os planos');
    });
  }

  getSalesman() {
    let userType = localStorage.getItem('dental_y');

    if (userType == 'BROKER') {
      let state = this.state;
      state.chooseSalesmanFlag = true;
      state.chooseSalesmanSelect = localStorage.getItem('dental_v_i');
      state.salesmanId = localStorage.getItem('dental_v_i');
      this.setState(state);

      // Pega os dados da corretora
      axios.get(urlBase.loopBack + 'Brokers?filter={"where":{"userId":"'+localStorage.getItem('dental_u')+'"}}')
      .then((result) => {
        if (result.data && result.data.length > 0) {
          let filter = '{"where":{"brokerId":"'+result.data[0].id+'"},"include":"user"}';

          // Pega os dados do vendedor
          axios.get(urlBase.loopBack + 'Salesmans?filter='+filter)
          .then((result2) => {
            let state = this.state;
            state.listSalesman = result2.data;
            this.setState(state);
          })
          .catch(function (erro) {
            alert(erro);
          });
        }
        else
          alert("Vendedores não encontrados");

      })
      .catch(function (erro) {
        alert(erro);
      });
    }
    else if (userType == 'BACKOFFICE') {
      let state = this.state;
      state.chooseSalesmanFlag = true;
      state.chooseSalesmanSelect = localStorage.getItem('dental_v_i');
      state.salesmanId = localStorage.getItem('dental_v_i');
      this.setState(state);

      // Pega os dados da corretora
      axios.get(urlBase.loopBack + 'Accounts/me/broker?access_token='+localStorage.getItem('dental_t'))
      .then((result) => {
        if (result.data) {
          let filter = '{"where":{"brokerId":"'+result.data.id+'"},"include":"user"}';

          // Pega os dados do vendedor
          axios.get(urlBase.loopBack + 'Salesmans?filter='+filter)
          .then((result2) => {
            let state = this.state;
            state.listSalesman = result2.data;
            this.setState(state);
          })
          .catch(function (erro) {
            alert(erro);
          });
        }
        else
          alert("Vendedores não encontrados");

      })
      .catch(function (erro) {
        alert(erro);
      });
    }
    else if (userType == 'PJCADASTRO') {
      let state = this.state;
      //state.chooseSalesmanFlag = true;
      state.chooseBrokerFlag = true;
      //state.chooseSalesmanSelect = localStorage.getItem('dental_v_i');
      state.salesmanId = localStorage.getItem('dental_v_i');
      this.setState(state);

      // Pega as corretoras
      axios.get(urlBase.loopBack + 'Brokers?filter={"include":"user"}')
      .then((result) => {
        if (result.data) {
          let state = this.state;
          state.listBroker = result.data;
          this.setState(state);
        }
        else
          alert("Corretoras não encontrados");

      })
      .catch(function (erro) {
        alert(erro);
      });
    }
  }
  getAddressType(){
    // Pega a lista de tipos de endereço
    axios.get(urlBase.loopBack + 'APIS4s/tipoLogradouro')
    .then((result) => {
      let state = this.state;
      state.addressTypeList = result.data;
      this.setState(state);
    })
    .catch(function (erro) {
      alert(erro);
    });
  }

  handleChange(e, maskedvalue, floatvalue) {
    if (e.target.name === 'justifyValue') {
      console.log('JUSTIFICATIVA:', e.target.value);
    }
    let state = this.state;

    if (e.target.value.replace(/[^a-z0-9]/gi,'').length > 0)
      this.errorField[e.target.name] = '';

    // Para o campo NÚMERO em endereço
    if (floatvalue != undefined)
      state[e.target.name] = floatvalue;
    else
      state[e.target.name] = e.target.value.toUpperCase();

    this.setState(state);

    // Pesquisa o CEP
    if (e.target.name == 'cep') {
       if (e.target.value.replace(/[^\d]+/g,"").length == 8) {
          this.getAddress(e.target.value);
       } else {
        this.errorField[e.target.name] = 'CEP INVÁLIDO';
       }
    }   

    // Verifica tamanho do campo NOME FANTASIA
    if (e.target.name == 'fantasyName') {
      if (e.target.value.length > 60 ) {
        state[e.target.name] = state[e.target.name].substring(0, 60);
        this.errorField[e.target.name] = 'Tamanho máximo: 60';
      }
      else
        this.errorField[e.target.name] = '';
    }

    // Verifica tamanho do campo NOME EMPRESARIAL
    if (e.target.name == 'businessName') {
      if (e.target.value.length > 60 ) {
        state[e.target.name] = state[e.target.name].substring(0, 60);
        this.errorField[e.target.name] = 'Tamanho máximo: 60';
      }
      else
        this.errorField[e.target.name] = '';
    }

    if (e.target.name == 'legalResponsibleCpf' && e.target.value.replace(/[^\d]+/g,"").length == 11)
      this.validateCpf(e.target.value);

    if (e.target.type == 'email') {
      if (e.target.value.length > 0)
        this.validateEmail(e.target.value, e.target.name);
      else
        this.errorField[e.target.name] = '';
    }
  }
  //APIS4s/Endereco
  getAddress(cep) {
    document.getElementById('loading_address').style.display = 'inline-block';//icone loading
    let dataPost = {
      'cep': cep
    };

    // Pega o endereço
    axios.post(urlBase.loopBack + 'APIS4s/Endereco', dataPost)
    .then((result) => {
      if (result.data != null) {
        // Atualiza a lista de cidades e de bairros
        let state = this.state;
        state.cityList = [];
        state.districtList = [];
        state.state = result.data.IdUf;
        state.addressType = result.data.IdTipoLogradouro;
        state.address = result.data.Logradouro;
        state.city = result.data.IdMunicipio;
        state.district = result.data.IdBairro;
        this.setState(state);
        this.getCity(result.data.IdUf);
        this.getDistrict(result.data.IdMunicipio);
      }
      else {
        this.errorField.cep = "Cep não encontrado! informe os campos de endereço manualmente";
        document.getElementById('loading_address').style.display = 'none';
      }
    })
    .catch(function () {
      this.errorField.cep = "Encontrado problema ao pesquisar o CEP";
      document.getElementById('loading_address').style.display = 'none';
    }.bind(this));
  }
  //APIS4s/UFs
  getStates(){
    // Pega a lista de estados
    axios.get(urlBase.loopBack + 'APIS4s/UFs')
    .then((result) => {
      let state = this.state;
      state.stateList = result.data;
      this.setState(state);
    })
    .catch(function (erro) {
      console.log(erro);
    });
  }
  //APIS4s/Municipios
  getCity(idState) {
    let dataPost = {
      'idUF': idState
    };
    // Pega a lista de cidades
    axios.post(urlBase.loopBack + 'APIS4s/Municipios', dataPost)
    .then((result) => {
      let state = this.state;
      state.cityList = result.data;
      this.setState(state);
    })
    .catch(function (erro) {
      alert(erro);
    });
  }
  //APIS4s/Bairros
  getDistrict(IdCity) {
    let dataPost = {
      'idCity': IdCity
    };

    // Pega a lista de bairros
    axios.post(urlBase.loopBack + 'APIS4s/Bairros', dataPost)
    .then((result) => {
      let state = this.state;
      state.districtList = result.data;
      this.setState(state);

      //definição do centro de custo
      axios.get(urlBase.loopBack + 'Cities?filter={"where":{"codeS4":"'+IdCity+'"},"include":"costCenter"}')
      .then((result2) => {
        document.getElementById('addressNumber').focus();
        document.getElementById('loading_address').style.display = 'none';

        if (result2.data[0] == undefined) {
          axios.get(urlBase.loopBack + 'Cities?filter={"where":{"default":true},"include":"costCenter"}')
          .then((result3) => {
            // Padrão João Pessoa
            let state = this.state;
            state.costCenter = result3.data[0].costCenter.name;
            this.setState(state);
          })
          .catch(function (erro) {
            alert('Erro ao buscar cidade padrão: '+erro);
          });// Fim centro de custo padrão
        }
        else {
          let state = this.state;
          state.costCenter = result2.data[0].costCenter.name;
          this.setState(state);
        }
      })
      .catch(function (erro) {
        alert('Erro ao buscar cidades: '+erro);
      });// Fim centro de custo
    })
    .catch(function (erro) {
      alert(erro);
    });
  }

  handleChangeSelectField(name, event, index, value) {
    let state = this.state;
    state[name] = value;

    if (value == 'NULL' && this.requiredFields[name] == true)
      this.errorField[name] = 'Campo obrigatório';
    else {
      this.errorField[name] = '';
      if (name == 'state')
        this.getCity(value);
      if (name == 'city')
        this.getDistrict(value);
    }

    if (name == 'effectiveDate')
      this.setEffectiveDateCol(value);

    this.setState(state);
  }

  validateCpf(value) {
    let cpf = value.replace(/[^\d]+/g,"");
    let test = true;
    let add = 0, i = 0, rev = 0;

    if (cpf.length != 11 ||
        cpf == "00000000000" ||
        cpf == "11111111111" ||
        cpf == "22222222222" ||
        cpf == "33333333333" ||
        cpf == "44444444444" ||
        cpf == "55555555555" ||
        cpf == "66666666666" ||
        cpf == "77777777777" ||
        cpf == "88888888888" ||
        cpf == "99999999999"){
      test = false;
    }
    else {
      // Valida 1° digito
      for (i=0; i < 9; i ++)
        add += parseInt(cpf.charAt(i)) * (10 - i);
        rev = 11 - (add % 11);
        if (rev == 10 || rev == 11){
          rev = 0;
        }
        if (rev != parseInt(cpf.charAt(9))){
          test = false;
        }
      // Valida 2° digito
      add = 0;
      for (i = 0; i < 10; i ++){
        add += parseInt(cpf.charAt(i)) * (11 - i);
      }
      rev = 11 - (add % 11);
      if (rev == 10 || rev == 11){
        rev = 0;
      }
      if (rev != parseInt(cpf.charAt(10))){
        test = false;
      }
    }

    if (test == true)
      this.errorField.legalResponsibleCpf = '';
    else
      this.errorField.legalResponsibleCpf = 'CPF inválido';
  }

  validateEmail(value, field) {
    let email = value,
        emailReg=/^([\w-]+(?:\.[\w-]+)*)@((?:[\w-]+\.)*\w[\w-]{0,66})\.([a-z]{2,6}(?:\.[a-z]{2})?)$/i;

    if (!emailReg.test(email))
      this.errorField[field] = 'Email inválido';
    else
      this.errorField[field] = '';
  }

  setStep(step) {
    let state = this.state;
    // Da primeira parte indo para a segunda
    // Verifica os campos obrigatórios
    if (step == 2 && this.state.stepForm == 1) {

      if (step == 2){
        // Suporte solicitou a retirada da validação dos docomento
        if (!this.validateImages()) {
              return;
        }
      }

    //  if (this.checkRequiredFields() == true && this.validateCnpj() == true && this.validateImages()==true) {
      if (this.checkRequiredFields() == true && this.validateCnpj() == true ) {   
        state.stepForm = step;
      }
    }
    else
      state.stepForm = step;

    this.setState(state);
    document.getElementById('div_top').scrollIntoView();
  }

  checkRequiredFields() {
    let firstField = false;
    let result = true;

    for (let key in this.requiredFields) {
      if (this.requiredFields[key] == true && this.state[key].length == 0 ||
         this.requiredFields[key] == true && this.state[key] == 'NULL') {

        this.errorField[key] = 'Campo obrigatório';
        result = false;

        if (document.getElementById('i_'+key) != null) {
          if (firstField == false) {
            document.getElementById('i_'+key).scrollIntoView();
            firstField = true;
          }
        }
      }
      else
        this.errorField[key] = '';
    }

    return result;
  }
  // Paulo Verificar aqui o erro
  checkRequiredFields2() {
    let firstField = false;
    let result = true;

    // Função auxiliar para registrar erro e rolar a tela até o elemento
    const setError = (key, message = 'Campo obrigatório') => {
      this.errorField[key] = message;
      result = false;

      if (!firstField) {
        const element = document.getElementById(key);
        if (element) {
          element.scrollIntoView({ behavior: 'smooth' });
          firstField = true;
        }
      }
    };

    const clearError = (key) => {
      this.errorField[key] = '';
    };

    for (let key in this.requiredFields2) {
      if (!this.requiredFields2[key]) continue;

      const fieldValue = this.state[key];

      if (key === 'amountHolder') {
        if (fieldValue === 0 || fieldValue === '0' || !fieldValue) {
          setError('amountHolder');
        } else {
          clearError('amountHolder');
        }
      } else if (key === 'amountOrto') {
        if (this.state.checkPlanOrto) {
          if (fieldValue === 0 || fieldValue === '0' || !fieldValue) {
            setError('amountOrto');
          } else {
            clearError('amountOrto');
          }
        }
      } else {
        // Trata null, undefined, string vazia e literal 'NULL'
        const isInvalid = 
          fieldValue === null || 
          fieldValue === undefined || 
          fieldValue.toString().trim().length === 0 || 
          fieldValue === 'NULL';

        if (isInvalid) {
          setError(key);
        } else {
          clearError(key);
        }
      }
    }

    // Validação da justificativa de valor divergente
    /*
    if (this.state.valuePlanDivergent && (!this.state.justifyValue || this.state.justifyValue.trim().length === 0)) {
      setError('justifyValue');
    } else {
      clearError('justifyValue');
    }
  */

  if (
    this.state.valuePlanDivergent === true &&
    (!this.state.justifyValue ||
    this.state.justifyValue.toString().trim() === '')
  ) {
    setError('justifyValue', 'Justificativa obrigatória');
  } else {
    clearError('justifyValue');
  }

    if (this.state.valuePlanOrtoDivergent && (!this.state.justifyValueOrto || this.state.justifyValueOrto.trim().length === 0)) {
      setError('justifyValueOrto');
    } else {
      clearError('justifyValueOrto');
    }
    // Força atualização da UI caso errorField seja refletido no render
    this.forceUpdate(); 


    return result;
  }

  typeOfContractChange(e, value) {
    let state = this.state;
    state.typeOfContract = value;
    this.setState(state);
  }
  tipoTributacaoChange(e, value) {
    let state = this.state;
    state.tipoTributacao = value;
    this.setState(state);
  }
  amountUsersChange(e, maskedvalue, floatvalue) {
    let value = '';
    let state = this.state;

    if (floatvalue != null && floatvalue != undefined)
      state[e.target.name] = floatvalue;

    let sum = state.amountHolder + state.amountDependent;

    if (state.checkPlanOrto == true)
      sum = sum  + state.amountOrto;

    if (sum >= 1 && sum <= 9)
      value = "01-09";
    else if (sum >= 10 && sum <= 19)
      value = "10-19";
    else if (sum >= 20 && sum <= 29)
      value = "20-29";
    else if (sum >= 30)
      value = "30";

    state.amountUsers = value;
    this.setState(state);

    this.setAmountUsersCol(value);
    this.verifyValueAmountUsers(value);
    this.blurAmountUsersValue(value);
  }

  setAmountUsersCol(value) {
    let list = {
      '01-09': '1', '10-19': '1', '20-29': '1', '30': '2'
    };
    let elements = document.getElementsByClassName("col_"+list[value]+"_style_user");
    let defaultList = [1, 2];

    // Cor padrão
    for (let i = 0; i < defaultList.length; i++) {
      let el = document.getElementsByClassName("col_"+defaultList[i]+"_style_user");
      for (let j = 0; j < el.length; j++) {
        el[j].style.backgroundColor = '#fff';
        el[j].style.fontWeight = 'normal';
        el[j].style.color = '#ccc';
        el[j].style.border = 'none';
        el[j].style.borderBottom = '1px solid rgb(224, 224, 224)';
      }
    }

    for (let i = 0; i < elements.length; i++) {
      elements[i].style.backgroundColor = 'rgb(99, 202, 124)';
      elements[i].style.color = '#000';
      elements[i].style.fontWeight = 'bold';
      elements[i].style.border = '1px solid #606060';
    }

  }

  verifyValueAmountUsers(value) {
    let valueList = {
      '01-09': 'value2',
      '10-19': 'value3',
      '20-29': 'value4',
      '30': 'value4',
    };
    let state = this.state;

    if (value.length > 0) {
      for (let i = 0; i < state.plansPjList.length; i++) {
        if (state.plansPjList[i].codeS4 === 0){
            if (state.plansPjList[i].ticketTable.value2.length > 0) {
              if (value == '01-09') {
                state.amountUsersValueHolder = state.plansPjList[i].ticketTable.value2;
                state.amountUsersValueDependent = state.plansPjList[i].ticketTable.value2;
                state.amountUsersValueHolderStr = state.plansPjList[i].ticketTable.value2;
                state.amountUsersValueDependentStr = state.plansPjList[i].ticketTable.value2;
                state.amountUsersValueShow = 'R$ ' + state.plansPjList[i].ticketTable.value2;
              }
              else {
                state.amountUsersValueHolder = state.plansPjList[i].ticketTable[valueList[value]];
                state.amountUsersValueDependent = state.plansPjList[i].ticketTable[valueList[value]];
                state.amountUsersValueHolderStr = state.plansPjList[i].ticketTable[valueList[value]];
                state.amountUsersValueDependentStr = state.plansPjList[i].ticketTable[valueList[value]];
                state.amountUsersValueShow = 'R$ ' + state.plansPjList[i].ticketTable[valueList[value]];
              }
            }

        }
        if (state.plansPjList[i].codeS4 === 2){
          if (state.plansPjList[i].value.length > 0 ) {
            state.checkPlanOrtoValue = 'R$ ' + state.plansPjList[i].ticketTable.value2;
            state.amountUsersValueOrto = state.plansPjList[i].ticketTable.value2;
            if (state.valorPlanOrtoFinal === '')
                state.valorPlanOrtoFinal = state.plansPjList[i].ticketTable.value2;

          }
        }        
      }
    }
    
    this.setState(state);
  }

  changeAmountUsersValue(e, maskedvalue, floatvalue) {
    let state = this.state;
    state[e.target.name] = floatvalue;
    state[e.target.name+'Str'] = maskedvalue.replace('R$ ','');
    this.setState(state);
  }

  blurAmountUsersValue(value=null) {
    let valueList = {
      '01-09': 'value2',
      '10-19': 'value3',
      '20-29': 'value4',
      '30': 'value4',
    };
    let state = this.state;

    if (value == null || value == undefined)
      value = state.amountUsers;

    for (let i = 0; i < state.plansPjList.length; i++) {
      // Não é preço para plano orto
      if (state.plansPjList[i].codeS4 === 0){
        if (state.plansPjList[i].ticketTable.value2.length > 0) {
          state.justifyValue = '';
          if (value == '01-09') {
            if (state.plansPjList[i].ticketTable.value2 != state.amountUsersValueHolderStr ||
                state.plansPjList[i].ticketTable.value2 != state.amountUsersValueDependentStr) {
              state.valuePlanDivergent = true;
            }
            else
              state.valuePlanDivergent = false;
              
          }
          else {
            if (state.plansPjList[i].ticketTable[valueList[value]] != state.amountUsersValueHolderStr ||
              state.plansPjList[i].ticketTable[valueList[value]] != state.amountUsersValueDependentStr) {
              state.valuePlanDivergent = true;
            }
            else
              state.valuePlanDivergent = false;
          }

          break;
        }
      }

    }
    for (let i = 0; i < state.plansPjList.length; i++) {

        if (state.plansPjList[i].codeS4 === 2) {

            if (state.plansPjList[i].ticketTable.value2.length > 0) {

                const valorReferencia = parseFloat(
                    state.plansPjList[i].ticketTable.value2
                        .replace('.', '')
                        .replace(',', '.')
                );

                const valorInformado = parseFloat(
                state.valorPlanOrtoFinal
                  .toString()
                  .replace('R$', '')
                  .trim()
                  .replace('.', '')
                  .replace(',', '.')
                )

                state.valuePlanOrtoDivergent =
                    valorReferencia !== valorInformado;
            }
            break;
        }
    }


    this.setState(state);
  }

  checkPlanOrtoFn(e, isInputChecked) {
    
    let state = this.state;
    state.justifyValueOrto = '';
    this.setState({
      valuePlanOrtoDivergent: false
    });
    this.errorField.justifyValueOrto = '';    
    if (isInputChecked)
      state.valorPlanOrtoFinal = state.checkPlanOrtoValue;
    state.checkPlanOrto = isInputChecked;
    state.amountOrto = 0;
    this.setState(state);

    this.amountUsersChange();
  }

  setEffectiveDateCol(numCol) {
    // {DIA_ESCOLHIDO: NUM_COLUNA}
    let list = {
      '01': '1', '02': '1', '03': '1', '04': '1', '05': '1',
      '06': '2', '07': '2', '08': '2', '09': '2', '10': '2',
      '11': '3', '12': '3', '13': '3', '14': '3', '15': '3',
      '16': '4', '17': '4', '18': '4', '19': '4', '20': '4',
      '21': '5', '22': '5', '23': '5', '24': '5', '25': '5',
      '26': '6', '27': '6', '28': '6', '29': '6', '30': '6',
    };
    // {DIA_ESCOLHIDO: VENCIMENTO_MENSAL}
    let list2 = {
      '01': '05', '02': '05', '03': '05', '04': '05', '05': '05',
      '06': '10', '07': '10', '08': '10', '09': '10', '10': '10',
      '11': '15', '12': '15', '13': '15', '14': '15', '15': '15',
      '16': '20', '17': '20', '18': '20', '19': '20', '20': '20',
      '21': '25', '22': '25', '23': '25', '24': '25', '25': '25',
      '26': '30', '27': '30', '28': '30', '29': '30', '30': '30',
    };
    // {DIA_ESCOLHIDO: DIA_DE_CORTE}
    let list3 = {
      '01': '14', '02': '14', '03': '14', '04': '14', '05': '14',
      '06': '19', '07': '19', '08': '19', '09': '19', '10': '19',
      '11': '24', '12': '24', '13': '24', '14': '24', '15': '24',
      '16': '27', '17': '27', '18': '27', '19': '27', '20': '27',
      '21': '4', '22': '4', '23': '4', '24': '4', '25': '4',
      '26': '9', '27': '9', '28': '9', '29': '9', '30': '9',
    };
    let elements = document.getElementsByClassName("col_"+list[numCol]+"_style");
    let defaultList = [1, 2, 3, 4, 5, 6];
    let state = this.state;
    // Cor padrão
    for (let i = 0; i < defaultList.length; i++) {
      let el = document.getElementsByClassName("col_"+defaultList[i]+"_style");
      for (let j = 0; j < el.length; j++) {
        el[j].style.backgroundColor = '#fff';
        el[j].style.fontWeight = 'normal';
        el[j].style.color = '#ccc';
        el[j].style.border = 'none';
        el[j].style.borderBottom = '1px solid rgb(224, 224, 224)';
      }
    }

    for (let i = 0; i < elements.length; i++) {
      elements[i].style.backgroundColor = 'rgb(99, 202, 124)';
      elements[i].style.fontWeight = 'bold';
      elements[i].style.color = '#000';
      elements[i].style.border = '1px solid #606060';
    }

    state.effectiveDate = numCol;
    state.monthlyExpiration = list2[numCol];
    state.cuttingDay = list3[numCol];
   
    this.setState(state);
  }

  beforeSubmitForm () {
    // Planilha obrigatória
    if (document.getElementById('imagem_usersTable').value.length > 0) {
      if (localStorage.getItem('dental_y') == 'SALESMAN') {
        let filter = 'Salesmans?filter={"where":{"userId":"' + localStorage.getItem('dental_u') +'"}}';
  
        axios.get(urlBase.loopBack + filter)
        .then((response) => {
          let state = this.state;
          state.salesmanId = response.data[0].id;
          state.chanelConfirm = "EMAIL";
          this.setState(state);
          this.saveCompany();
        })
        .catch(() => {
          alert('Problema encontrado ao buscar o vendedor');
        });
      }
      else {
        let state = this.state;
        state.salesmanId = localStorage.getItem('dental_v_i');
        this.setState(state);
  
        this.saveCompany();
      }
    }
    else {
      let state = this.state;
      state.imagesDocs["usersTable"] = 'error';
      state.usersTableError = 'A PLANILHA É OBRIGATÓRIA';
      this.setState(state);
      document.getElementById('i_content_file').scrollIntoView();
    }
  }

  saveCompany() {
    let state = this.state;
    // Loadind
    state.stepForm = 3;
    this.setState(state);

    // Verifica a extensão da planilha
    if (this.state.usersTableExt.length > 0 &&
        this.state.usersTableExt != 'xlsx' &&
        this.state.imagesDocs.usersTable != 'error') {
      let state = this.state;
      // Loadind
      state.stepForm = 2;
      this.setState(state);

    }
    else {
      // problema aqui 
      if (this.checkRequiredFields2() == true) {
        let costCenterConfig = {
          "João Pessoa": 1, 
          "Campina Grande": 2,
          "Guarabira": 3,
        };
        let plansPjListS4 = {
          '01-09': 1065,
          '10-19': 1065,
          '20-29': 1065,
          '30': 1065,
        };


        // TRATAR AQUI A INCLUSÃO DO PLANO ORTO
        let codPlanoOrto = "";
        let valorPlanoOrto = "";
        if (this.state.checkPlanOrto) {
          codPlanoOrto = 2;
          valorPlanoOrto = this.state.valorPlanOrtoFinalStr;
        } else {
          codPlanoOrto = "";
          valorPlanoOrto = ""
        }

        let dataPost = {
          cnpj: this.state.cnpj,
          openingDate: '',
          fantasyName: this.state.fantasyName,
          businessName: this.state.businessName,
          cep: this.state.cep,
          state: this.state.state,
          city: this.state.city,
          addressType: this.state.addressType,
          address: this.state.address,
          addressNumber: this.state.addressNumber,
          addressComplement: this.state.addressComplement,
          district: this.state.district,
          homePhone: this.state.homePhone,
          cellPhone: this.state.cellPhone,
          cellPhone2: this.state.cellPhone2,
          legalResponsible: this.state.legalResponsible,
          legalResponsibleRg: this.state.legalResponsibleRg,
          legalResponsibleCpf: this.state.legalResponsibleCpf,
          legalResponsibleEmail: this.state.legalResponsibleEmail,
          infoWorkerName: this.state.infoWorkerName,
          infoEmailContact: this.state.infoEmailContact,
          infoHomePhone: this.state.infoHomePhone,
          infoCellPhone: this.state.infoCellPhone,
          infoEmailInvoice: this.state.infoEmailInvoice,
          infoPersonInCharge: this.state.infoPersonInCharge,
          infoPersonInChargePhone: this.state.infoPersonInChargePhone,
          effectiveDate: this.state.effectiveDate,
          effectiveDateMonth: this.state.effectiveDateMonth,
          effectiveDateYear: this.state.effectiveDateYear,
          monthlyExpiration: this.state.monthlyExpiration,
          cuttingDay: parseInt(this.state.cuttingDay) + 1,
          typeOfContract: this.state.typeOfContract,
          tipoTributacao: this.state.tipoTributacao,
          proRata : "0",
          enviaBoletoAnexoEmail : "1",
          salesmanId: this.state.salesmanId,
          costCenterS4: costCenterConfig[this.state.costCenter],
          status: "AGUARDANDO PAGAMENTO",
          chanelConfirm : "EMAIL",
          valuePlanHolder: this.state.amountUsersValueHolderStr,
          valuePlanDependent: this.state.amountUsersValueDependentStr,
          valuePlanDivergent: this.state.valuePlanDivergent,
          valuePlanOrtoDivergent : this.state.valuePlanOrtoDivergent,
          includesOrto: this.state.checkPlanOrto,
          justifyValue: this.state.justifyValue,
          justifyValueOrto: this.state.justifyValueOrto,
          amountHolder: this.state.amountHolder,
          amountDependent: this.state.amountDependent,
          amountOrto: this.state.amountOrto,
          planS4: plansPjListS4[this.state.amountUsers],
          planOrtoS4 :  codPlanoOrto,
          valuePlanOrto: valorPlanoOrto,
        };
        let dateCalc = this.state.openingDate.split('/');
        dataPost.openingDate = dateCalc[2]+'-'+dateCalc[1]+'-'+dateCalc[0];
        /*
        axios.post(urlBase.loopBack + 'Companies', dataPost)
        .then((result) => {
          let dataPost2 = {
            id: result.data.id,
            imagesDocId: '',
            imagesDocs: {
              usersTable: document.getElementById('imagem_usersTable').value,
              usersTableExt: this.state.usersTableExt,
              rg: document.getElementById('imagem_rg').value,
              cnh: document.getElementById('imagem_cnh').value,
              rg2: document.getElementById('imagem_rg2').value,
              cpf: document.getElementById('imagem_cpf').value,
              cnpj: document.getElementById('imagem_cnpj').value,
              address: document.getElementById('imagem_address').value,
              // physicalContract1: document.getElementById('imagem_physicalContract1').value,
              // physicalContract2: document.getElementById('imagem_physicalContract2').value,
              // physicalContract3: document.getElementById('imagem_physicalContract3').value,
              others: document.getElementById('imagem_others').value,
            },
          };
  
          axios.post(urlBase.loopBack + 'Companies/saveDocsCompany', dataPost2)
          .then(() => {
            let state = this.state;
            // Sucesso
            state.stepForm = 4;
            this.setState(state);

            if (this.state.chanelConfirm == 'EMAIL') {
              let dataPost3 = {
                id: result.data.id
              };

              axios.post(urlBase.loopBack + 'Companies/SendEmailCompanyCreated', dataPost3)
              .then(() => {    
                
              })
              .catch(function () {
               alert('Problema encontrado ao enviar email');
              }.bind(this));
            }
          })
          .catch(function () {
            let state = this.state;
            // Erro
            state.stepForm = 5;
            this.setState(state);
          }.bind(this));
        })
        .catch(function () {
          let state = this.state;
          // Erro
          state.stepForm = 5;
          this.setState(state);
        }.bind(this));
        */
        axios.post(urlBase.loopBack + 'Companies', dataPost)
          .then((result) => {
            let dataPost2 = {
              id: result.data.id,
              imagesDocId: '',
              imagesDocs: {
                usersTable: document.getElementById('imagem_usersTable').value,
                usersTableExt: this.state.usersTableExt,
                rg: document.getElementById('imagem_rg').value,
                cnh: document.getElementById('imagem_cnh').value,
                rg2: document.getElementById('imagem_rg2').value,
                cpf: document.getElementById('imagem_cpf').value,
                cnpj: document.getElementById('imagem_cnpj').value,
                address: document.getElementById('imagem_address').value,
                others: document.getElementById('imagem_others').value,
              },
            };

            // Função interna para enviar o e-mail se necessário
            const sendEmailIfRequired = () => {
              if (this.state.chanelConfirm === 'EMAIL') {
                let dataPost3 = { id: result.data.id };

                axios.post(urlBase.loopBack + 'Companies/SendEmailCompanyCreated', dataPost3)
                  .catch(function () {
                    alert('Problema encontrado ao enviar email');
                  });
              }
            };

            axios.post(urlBase.loopBack + 'Companies/saveDocsCompany', dataPost2)
              .then(() => {
                let state = this.state;
                state.stepForm = 4; // Sucesso total
                this.setState(state);
              })
              .catch(function (error) {
                if (error.response && error.response.status === 413) {
                  alert('Um ou mais arquivos anexados excedem o tamanho máximo permitido. Reduza o tamanho das imagens e tente novamente. Para continuar o processo, acesse a empresa novamente na seção de aguardando pagamento.');                  
                  window.location.href = `${urlBase.client}panel/companylist/pjawaitingpayment`;
                } else {
                  alert('Ocorreu um erro ao salvar os documentos da empresa.');
                }

                let state = this.state;
                state.stepForm = 5; // Erro no envio dos documentos
                this.setState(state);
              }.bind(this))
              .finally(() => {
                // O e-mail será disparado independentemente de ter dado sucesso ou erro nos documentos
                sendEmailIfRequired();
              });
          })
          .catch(function () {
            let state = this.state;
            state.stepForm = 5; // Erro na criação inicial da Company
            this.setState(state);
          }.bind(this));  
   
      }
      else {

        let state = this.state;
        // Loadind
        state.stepForm = 2;
        this.setState(state);
      }
    }
  }

  confirmationForm (e, value) {    
    let state = this.state;
    state.chanelConfirm = value;
    this.setState(state);
  }

  // Monitora mudanças a atualiza estados do Select 'Vendedor'
  salesmanChange(event, index, payload) {
    let state = this.state;
    state.chooseSalesmanSelect = payload;
    state.salesmanId = payload;

    if (this.state.chooseSalesmanSelect == 'null')
      this.errorField.chooseSalesmanSelect = 'Campo obrigatório';
    else
      this.errorField.chooseSalesmanSelect = '';

    this.setState(state);

    localStorage.setItem('dental_v_i', payload);
  }

  // Monitora mudanças e atualiza estados do Select 'Corretora'
  brokerChange(event, index, payload) {
    let filter = '{"where":{"brokerId":"'+payload+'"},"include":"user"}';
    let state = this.state;
    state.chooseBrokerSelect = payload;
    state.salesmanId = payload;

    if (this.state.chooseBrokerSelect == 'null')
      this.errorField.chooseBrokerSelect = 'Campo obrigatório';
    else
      this.errorField.chooseBrokerSelect = '';

    this.setState(state);

    //localStorage.setItem('dental_v_i', payload);

    // Pega os dados do vendedor
    axios.get(urlBase.loopBack + 'Salesmans?filter='+filter)
    .then((result2) => {
      let state = this.state;
      state.chooseSalesmanFlag = true;
      state.listSalesman = result2.data;
      this.setState(state);
    })
    .catch(function (erro) {
      alert(erro);
    });
  }

  verifySalesman(step) {
    let state = this.state;
    let userType = localStorage.getItem('dental_y');

    if (userType == 'BROKER' || userType == 'BACKOFFICE') {
      // Caso ainda não tenha escolhido um vendedor
      if (this.state.chooseSalesmanSelect == 'null') {
        this.errorField.chooseSalesmanSelect = 'Campo obrigatório';
        document.getElementById('div_top').scrollIntoView();
      }
      else {
        this.errorField.chooseSalesmanSelect = '';
        state.disabledSalesmanSelect = true;
        this.setStep(step);
      }
    }
    else {
      if (userType == 'PJCADASTRO') {
        // Caso ainda não tenha escolhido uma corretora
        if (this.state.chooseBrokerSelect == 'null') {
          this.errorField.chooseBrokerSelect = 'Campo obrigatório';
          document.getElementById('div_top').scrollIntoView();
        }
        else {
          this.errorField.chooseBrokerSelect = '';
          state.disabledBrokerSelect = true;

          // Caso ainda não tenha escolhido um vendedor
          if (this.state.chooseSalesmanSelect == 'null') {
            this.errorField.chooseSalesmanSelect = 'Campo obrigatório';
            document.getElementById('div_top').scrollIntoView();
          }
          else {
            this.errorField.chooseSalesmanSelect = '';
            state.disabledSalesmanSelect = true;
            this.setStep(step);
          }
        }
      }
      else
        this.setStep(step);
    }

    this.setState(state);
  }

  fileToBase64(typeDoc) {
    /*
    * @type pode ser: "usersTable"
    */

    let reader = new FileReader();
    let file = document.getElementById('doc_'+typeDoc).files[0];
    let ext = file.name.split('.').pop().toLowerCase();
    let state = this.state;

    if (typeDoc == 'usersTable')
      state.usersTableExt = ext;
    else {
      if (ext == 'pdf')
        state.imagesDocs[typeDoc] = "pdf";
      else
        state.imagesDocsUrl[typeDoc] = window.URL.createObjectURL(file);
    }

    state.imagesDocs[typeDoc] = ext;

    reader.onloadend = function() {
      document.getElementById('imagem_'+typeDoc).value = reader.result;
      // Interpretando a planilha
      if (ext == 'xlsx') {
        readXlsxFile(file).then((rows) => {
          let state = this.state;
          // Planilha vazia
          if (rows.length <= 3) {
            state.imagesDocs[typeDoc] = 'error';
            state.usersTableError = 'PLANILHA VAZIA - FAVOR PREENCHER ANTES DE ENVIAR';
          }
          else {

            let nomeTit = 0;
            let nomeDep = 1;
            let parentesco = 2;
            let cpf = 3;
          //  let cns = 4;
            let dataNasc = 5;
            let tipoPlano = 6;
            let nomeMae = 7;
            let sexo = 8;
           // let rg = 9;
           // let emissaoRg = 10;
            let celular = 11;
            //let email = 10;
            //let codigo = 11;

            for (let i = 3; i < rows.length; i++) {
              if (rows[i][nomeTit] == null && rows[i][nomeDep] == null) {
                state.imagesDocs[typeDoc] = 'error';
                state.usersTableError = 'FUNCIONÁRIO SEM NOME DE TITULAR E SEM NOME DE DEPENDENTE';
                document.getElementById('doc_'+typeDoc).value = "";
                document.getElementById('imagem_'+typeDoc).value = "";
                break;
              }
              if (rows[i][tipoPlano] == null) {
                state.imagesDocs[typeDoc] = 'error';
                state.usersTableError = 'O TIPO DE PLANO É OBRIGATÓRIO PARA TITULARES E DEPENDENTES';
                document.getElementById('doc_'+typeDoc).value = "";
                document.getElementById('imagem_'+typeDoc).value = "";
                break;
              }
              else {
                let tipoPlanoList = ['clínico', 'clinico', 'orto'];
                // Não é um tipo de plano válido
                if (tipoPlanoList.indexOf(rows[i][tipoPlano].toLowerCase()) < 0) {
                  state.imagesDocs[typeDoc] = 'error';
                  state.usersTableError = rows[i][tipoPlano] + ' - NÃO É UM TIPO DE PLANO VÁLIDO';
                  document.getElementById('doc_'+typeDoc).value = "";
                  document.getElementById('imagem_'+typeDoc).value = "";
                  break;
                }
              }

              // Linha do titular
              if (rows[i][nomeTit] != null && rows[i][nomeDep] == null) {
                // Verifica nome completo
                if (rows[i][nomeTit].indexOf('.') >= 0) {
                  state.imagesDocs[typeDoc] = 'error';
                  state.usersTableError = rows[i][nomeTit].toUpperCase()+' - NOME COMPLETO SEM ABREVIAÇÃO';
                  document.getElementById('doc_'+typeDoc).value = "";
                  document.getElementById('imagem_'+typeDoc).value = "";
                  break;
                }

                // Nome com acentuação
                if (this.checkAccentuation(rows[i][nomeTit]) == false) {
                  state.imagesDocs[typeDoc] = 'error';
                  state.usersTableError = rows[i][nomeTit].toUpperCase()+' - NÃO PERMITIDO ACENTUAÇÃO';
                  document.getElementById('doc_'+typeDoc).value = "";
                  document.getElementById('imagem_'+typeDoc).value = "";
                  break;
                }
                // Sem parentesco

                if (rows[i][parentesco] == null) {
                  state.imagesDocs[typeDoc] = 'error';
                  state.usersTableError = rows[i][nomeTit].toUpperCase()+' - SEM GRAU DE PARENTESCO INFORMADO';
                  document.getElementById('doc_'+typeDoc).value = "";
                  document.getElementById('imagem_'+typeDoc).value = "";
                  break;
                } else {
                  let listaCodParentesco = [1, 3, 4, 6, 8, 10 ]
                  if ( listaCodParentesco.indexOf(rows[i][parentesco]) === -1 ) {
                    state.imagesDocs[typeDoc] = 'error';
                    state.usersTableError = rows[i][nomeTit].toUpperCase()+' - CÓDIGO DO GRAU DE PARENTESCO INVÁLIDO';
                    document.getElementById('doc_'+typeDoc).value = "";
                    document.getElementById('imagem_'+typeDoc).value = "";
                    break;                    
                  }
                }

                // Sem CPF
                if (rows[i][cpf] == null) {
                  state.imagesDocs[typeDoc] = 'error';
                  state.usersTableError = rows[i][nomeTit].toUpperCase()+' - SEM CPF INFORMADO';
                  document.getElementById('doc_'+typeDoc).value = "";
                  document.getElementById('imagem_'+typeDoc).value = "";
                  break;
                }

                // Sem CNS
/*
                if (rows[i][cns] == null) {
                  state.imagesDocs[typeDoc] = 'error';
                  state.usersTableError = rows[i][nomeTit].toUpperCase()+' - SEM CNS INFORMADO';
                  document.getElementById('doc_'+typeDoc).value = "";
                  document.getElementById('imagem_'+typeDoc).value = "";
                  break;
                }      
                Sem RG
                if (rows[i][rg] == null) {
                  state.imagesDocs[typeDoc] = 'error';
                  state.usersTableError = rows[i][nomeTit].toUpperCase()+' - SEM RG INFORMADO';  
                  document.getElementById('doc_'+typeDoc).value = "";
                  document.getElementById('imagem_'+typeDoc).value = "";
                  break;
                }
                // Sem orgão expedidor do RG
                if (rows[i][emissaoRg] == null) {
                  state.imagesDocs[typeDoc] = 'error';
                  state.usersTableError = rows[i][nomeTit].toUpperCase()+' - SEM ORGÃO EXPEDIDOR DO RG INFORMADO';  
                  document.getElementById('doc_'+typeDoc).value = "";
                  document.getElementById('imagem_'+typeDoc).value = "";
                  break;
                }
                  */
                // Sem data de nascimento
                if (rows[i][dataNasc] == null) {
                  state.imagesDocs[typeDoc] = 'error';
                  state.usersTableError = rows[i][nomeTit].toUpperCase()+' - SEM DATA DE NASCIMENTO INFORMADO';
                  document.getElementById('doc_'+typeDoc).value = "";
                  document.getElementById('imagem_'+typeDoc).value = "";
                  break;
                }
                // Titular maior ou igual a 18 anos
                else {
                  let age = new Date(rows[i][dataNasc]);
                  if (this.calculateAge(age.getFullYear(), age.getMonth()+1,age.getDate()) < 18 ) {
                    state.imagesDocs[typeDoc] = 'error';
                    state.usersTableError = rows[i][nomeTit].toUpperCase()+' - DEVERÁ SER MAIOR DE IDADE (18 ANOS)';
                    document.getElementById('doc_'+typeDoc).value = "";
                    document.getElementById('imagem_'+typeDoc).value = "";
                  }
                }
                // Sem nome da mãe
                if (rows[i][nomeMae] == null) {
                  state.imagesDocs[typeDoc] = 'error';
                  state.usersTableError = rows[i][nomeTit].toUpperCase()+' - SEM NOME DA MÃE INFORMADO';  
                  document.getElementById('doc_'+typeDoc).value = "";
                  document.getElementById('imagem_'+typeDoc).value = "";
                  break;
                }
                // Sem sexo
                if (rows[i][sexo] == null) {
                  state.imagesDocs[typeDoc] = 'error';
                  state.usersTableError = rows[i][nomeTit].toUpperCase()+' - SEM SEXO INFORMADO';  
                  document.getElementById('doc_'+typeDoc).value = "";
                  document.getElementById('imagem_'+typeDoc).value = "";
                  break;
                }
                else {
                  if (rows[i][sexo].toUpperCase() != 'M' && rows[i][sexo].toUpperCase() != 'F') {
                    state.imagesDocs[typeDoc] = 'error';
                    state.usersTableError = rows[i][nomeTit].toUpperCase()+' COM SEXO INVÁLIDO. ACEITO: F/M';    
                    document.getElementById('doc_'+typeDoc).value = "";
                    document.getElementById('imagem_'+typeDoc).value = "";
                    break;
                  }
                }
                // Sem celular
                if (rows[i][celular] == null) {
                  state.imagesDocs[typeDoc] = 'error';
                  state.usersTableError = rows[i][nomeTit].toUpperCase()+' - SEM CELULAR INFORMADO';  
                  document.getElementById('doc_'+typeDoc).value = "";
                  document.getElementById('imagem_'+typeDoc).value = "";
                  break;
                }
              }
              // Linha dos dependentes
              else {
                // Verifica acentuação
                if (rows[i][nomeDep].indexOf('.') >= 0) {
                  state.imagesDocs[typeDoc] = 'error';
                  state.usersTableError = rows[i][nomeDep].toUpperCase()+' - NOME COMPLETO SEM ABREVIAÇÃO';
                  document.getElementById('doc_'+typeDoc).value = "";
                  document.getElementById('imagem_'+typeDoc).value = "";
                  break;
                }
                // Nome com acentuação
                if (this.checkAccentuation(rows[i][nomeDep]) == false) {
                  state.imagesDocs[typeDoc] = 'error';
                  state.usersTableError = rows[i][nomeDep].toUpperCase()+' - NÃO PERMITIDO ACENTUAÇÃO';
                  document.getElementById('doc_'+typeDoc).value = "";
                  document.getElementById('imagem_'+typeDoc).value = "";
                  break;
                }

                // Sem data de nascimento
                if (rows[i][dataNasc] == null) {
                  state.imagesDocs[typeDoc] = 'error';
                  state.usersTableError = rows[i][nomeDep].toUpperCase()+' - SEM DATA DE NASCIMENTO INFORMADO';  
                  document.getElementById('doc_'+typeDoc).value = "";
                  document.getElementById('imagem_'+typeDoc).value = "";
                  break;
                }
                else {
                  // Apartir de 10 anos CPF obrigatório
                  let age = new Date(rows[i][dataNasc]);
                  if (this.calculateAge(age.getFullYear(), age.getMonth()+1,age.getDate()) >= 10 && rows[i][cpf] == null) {
                    state.imagesDocs[typeDoc] = 'error';
                    state.usersTableError = rows[i][nomeDep].toUpperCase()+' - A PARTIR DE 10 ANOS CPF OBRIGATÓRIO';  
                    document.getElementById('doc_'+typeDoc).value = "";
                    document.getElementById('imagem_'+typeDoc).value = "";
                    break;
                  }
                }
                // Sem CNS

                // if (rows[i][cns] == null) {
                //   state.imagesDocs[typeDoc] = 'error';
                //   state.usersTableError = rows[i][nomeDep].toUpperCase()+' - SEM CNS INFORMADO';
                //   document.getElementById('doc_'+typeDoc).value = "";
                //   document.getElementById('imagem_'+typeDoc).value = "";
                //   break;
                // }          

                if (rows[i][parentesco] == null) {
                  state.imagesDocs[typeDoc] = 'error';
                  state.usersTableError = rows[i][nomeDep].toUpperCase()+' - SEM GRAU DE PARENTESCO INFORMADO';
                  document.getElementById('doc_'+typeDoc).value = "";
                  document.getElementById('imagem_'+typeDoc).value = "";
                  break;
                } else {
                  let listaCodParentesco = [1, 3, 4, 6, 8, 10 ]
                  if ( listaCodParentesco.indexOf(rows[i][parentesco]) === -1 ) {
                    state.imagesDocs[typeDoc] = 'error';
                    state.usersTableError = rows[i][nomeDep].toUpperCase()+' - CÓDIGO DO GRAU DE PARENTESCO INVÁLIDO';
                    document.getElementById('doc_'+typeDoc).value = "";
                    document.getElementById('imagem_'+typeDoc).value = "";
                    break;                    
                  }
                }       
         
                // Sem nome da mãe
                if (rows[i][nomeMae] == null) {
                  state.imagesDocs[typeDoc] = 'error';
                  state.usersTableError = rows[i][nomeDep].toUpperCase()+' - SEM NOME DA MÃE INFORMADO';  
                  document.getElementById('doc_'+typeDoc).value = "";
                  document.getElementById('imagem_'+typeDoc).value = "";
                  break;
                }
                // Sem sexo
                if (rows[i][sexo] == null) {
                  state.imagesDocs[typeDoc] = 'error';
                  state.usersTableError = rows[i][nomeDep].toUpperCase()+' - SEM SEXO INFORMADO';  
                  document.getElementById('doc_'+typeDoc).value = "";
                  document.getElementById('imagem_'+typeDoc).value = "";
                  break;
                }
                else {
                  if (rows[i][sexo].toUpperCase() != 'M' && rows[i][sexo].toUpperCase() != 'F') {
                    state.imagesDocs[typeDoc] = 'error';
                    state.usersTableError = rows[i][nomeDep].toUpperCase()+' COM SEXO INVÁLIDO. ACEITO: F ou M';    
                    document.getElementById('doc_'+typeDoc).value = "";
                    document.getElementById('imagem_'+typeDoc).value = "";
                    break;
                  }
                }
                // Celular do dependente
                 let idadeDep = new Date(rows[i][dataNasc]);
                 if (this.calculateAge(idadeDep.getFullYear(), idadeDep.getMonth()+1,idadeDep.getDate()) >= 18 ) {
                    if (rows[i][celular] == null) {
                      state.imagesDocs[typeDoc] = 'error';
                      state.usersTableError = rows[i][nomeDep].toUpperCase()+' - CELULAR É OBRIGATÓRIO (MARIOR QUE 18 ANOS)';
                      document.getElementById('doc_'+typeDoc).value = "";
                      document.getElementById('imagem_'+typeDoc).value = "";                                          
                    }                 
                 }                
              }
            }
          }

          this.setState(state);
        });
      }
      else
        this.setState(state);

    }.bind(this);
    reader.readAsDataURL(file);
  }

  calculateAge(anoAniv, mesAniv, diaAniv) {
    let anoAtual = this.state.currentTimeServer.year,
        mesAtual = this.state.currentTimeServer.month,
        diaAtual = this.state.currentTimeServer.day,
        qtsAnos = anoAtual - anoAniv;

    anoAniv = +anoAniv;
    mesAniv = +mesAniv;
    diaAniv = +diaAniv;

    if (mesAtual < mesAniv || mesAtual == mesAniv && diaAtual < diaAniv)
        qtsAnos--;

    return qtsAnos < 0 ? 0 : qtsAnos;
  }

  getCurrentTimeServer() {
    // Pega a data atual do servidor
    axios.post(urlBase.loopBack + 'Sales/currentTime')
    .then((response) => {
      let state = this.state;
      state.currentTimeServer = response.data;
      this.setState(state);
    })
    .catch(function () {
      alert('Problema encontrado ao pegar data do servidor');
    });
  }
  
  checkAccentuation(text) {
    let accentuationList = "áàãâäéèêëíìîïóòõôöúùûüÁÀÃÂÄÉÈÊËÍÌÎÏÓÒÕÖÔÚÙÛÜ";

    for (let i = 0; i < text.length; i++) {
      if (accentuationList.indexOf(text[i]) >= 0) {
        return false;
      }
    }

    return true;
  }

  validateCnpj() {
    let cnpj = this.state.cnpj.replace(/[^\d]+/g, '');
    let tamanho = cnpj.length - 2;
    let numeros = cnpj.substring(0, tamanho);
    let digitos = cnpj.substring(tamanho);
    let soma = 0;
    let pos = tamanho - 7;
    let resultado = 0;
    let erro = false;

    if (cnpj == '')
      erro = true;

    if (cnpj.length != 14)
      erro = true;

    if (cnpj == "00000000000000" ||
      cnpj == "11111111111111" ||
      cnpj == "22222222222222" ||
      cnpj == "33333333333333" ||
      cnpj == "44444444444444" ||
      cnpj == "55555555555555" ||
      cnpj == "66666666666666" ||
      cnpj == "77777777777777" ||
      cnpj == "88888888888888" ||
      cnpj == "99999999999999") {
        erro = true;
    }

    for (let i = tamanho; i >= 1; i--) {
      soma += numeros.charAt(tamanho - i) * pos--;

      if (pos < 2)
        pos = 9;
    }

    resultado = soma % 11 < 2 ? 0 : 11 - soma % 11;

    if (resultado != digitos.charAt(0))
      erro = true;

    tamanho = tamanho + 1;
    numeros = cnpj.substring(0, tamanho);
    soma = 0;
    pos = tamanho - 7;

    for (let i = tamanho; i >= 1; i--) {
      soma += numeros.charAt(tamanho - i) * pos--;

      if (pos < 2)
        pos = 9;
    }

    resultado = soma % 11 < 2 ? 0 : 11 - soma % 11;

    if (resultado != digitos.charAt(1))
      erro = true;

    if (erro == true) {
      this.errorField.cnpj = 'CNPJ inválido';
      return false;
    }
    else {
      this.errorField.cnpj = '';
      return true;
    }
  }

  onOpenModalTerms() {
    this.setState({ openTerms: true });
  }

  onCloseModalTerms() {
    this.setState({ openTerms: false });
  }

  validateCheckbox(id) {
    let state = this.state,
      checked = document.getElementById(id).checked;
    if (checked == false) {
      document.getElementById("alert_" + id).style.display = "block";
      state.resultValidateForm.push(false);
    } else {
      document.getElementById("alert_" + id).style.display = "none";
      state.resultValidateForm.push(true);
    }
    this.setState(state);
  }

  verifyCheck(id) {
    let state = this.state,
      checked = document.getElementById(id).checked;
    if (checked == false) {
      state.followProposal = false;
    } else {
      state.followProposal = true;
    }
    this.setState(state);
  }

  render() {
    return (
      <div>
         <input id="imagem_usersTable" type="hidden"/>
         <input id="imagem_rg" type="hidden"/>
         <input id="imagem_cnh" type="hidden"/>
         <input id="imagem_rg2" type="hidden"/>
         <input id="imagem_cpf" type="hidden"/>
         <input id="imagem_cnpj" type="hidden"/>
         <input id="imagem_address" type="hidden"/>
         <input id="imagem_physicalContract1" type="hidden"/>
         <input id="imagem_physicalContract2" type="hidden"/>
         <input id="imagem_physicalContract3" type="hidden"/>
         <input id="imagem_others" type="hidden"/>

        <p id="div_top" style={{marginBottom: 35}} className="title_form">PROPOSTA DE ADESÃO EMPRESARIAL</p>

        <Container className="form_container_panel2">
        {
          this.state.chooseBrokerFlag == true ? (

          <Row>
            <Col xs="12" sm="8" md="6" lg="6" style={{margin: '0 auto'}}>
              <SelectField
                disabled={this.state.disabledBrokerSelect}
                style={this.styles.input}
                errorText={this.errorField.chooseBrokerSelect}
                floatingLabelText="Corretora *"
                fullWidth={true}
                name="type"
                value={this.state.chooseBrokerSelect}
                onChange={this.brokerChange.bind(this)}
              >
                <MenuItem value="null" primaryText="Escolha uma corretora" />
              {this.state.listBroker.map((item, index) =>
                <MenuItem key={index} value={item.id} primaryText={item.user.name} />
              )}
              </SelectField>
            </Col>
          </Row>
          ) : ('')
        }

        {
          this.state.chooseSalesmanFlag == true ? (

          <Row>
            <Col xs="12" sm="8" md="6" lg="6" style={{margin: '0 auto'}}>
              <SelectField
                disabled={this.state.disabledSalesmanSelect}
                style={this.styles.input}
                errorText={this.errorField.chooseSalesmanSelect}
                floatingLabelText="Vendedor *"
                fullWidth={true}
                name="type"
                value={this.state.chooseSalesmanSelect}
                onChange={this.salesmanChange.bind(this)}
              >
                <MenuItem value="null" primaryText="Escolha um vendedor" />
              {this.state.listSalesman.map((item, index) =>
                <MenuItem key={index} value={item.id} primaryText={item.user.name} />
              )}
              </SelectField>
            </Col>
          </Row>
          ) : ('')
        }

        {
          this.state.stepForm == 1 ? (
          <Container className="form_container_internal_panel">
            {/**TForma de Confirmação  */}
            <fieldset style={Styles.fieldset}>
                  <legend style={Styles.legenda_filedset}>
                    FORMA DE CONFIRMAÇÃO
                </legend>            
                <Row>
                  <Col id="i_chanelConfirm" xs="12" sm="12" md="12" lg="12">
                    <RadioButtonGroup
                      id="forma_confirmacao"
                      name="chanelConfirm"
                      label="FORMA DE CONFIRMAÇÃO"
                      onChange={this.confirmationForm.bind(this)}
                      errorText={this.errorField.chanelConfirm}
                      valueSelected={this.state.chanelConfirm}
                    >
                      
                    {/* 
                    <RadioButton
                      value="VENDEDOR"
                      label="Proposta Física"
                    />
                  */}
                    <RadioButton
                      value="EMAIL"
                      label="Email"
                      aria-label='Email'

                    />
                  </RadioButtonGroup>
                  {
                    this.errorField.chanelConfirm.length > 0 ? (
                  <p className="error_radiobutton">{this.errorField.chanelConfirm}</p>
                    ) : ('')
                  }
                  </Col>
              </Row>
            </fieldset>
            {/**TIPO DE TRIBUTAÇÃO  */}
            <fieldset style={Styles.fieldset}>
                  <legend style={Styles.legenda_filedset}>
                    TIPO DE TRIBUTAÇÃO
                </legend> 
                <Row>
                  <Col id="i_tipoTributacao" xs="12" sm="12" md="12" lg="12">
                    <RadioButtonGroup
                      name="tipoTributacao"
                      id="id_tipo_tributacao"
                      onChange={this.tipoTributacaoChange.bind(this)}
                      errorText={this.errorField.tipoTributacao}
                      valueSelected={this.state.tipoTributacao}
                    >
                      <RadioButton
                        value="1"
                        label="Não Optante"
                        aria-label='Não Optante'

                      />
                      <RadioButton
                        value="2"
                        label="Lucro Real"
                        aria-label='Lucro real'
                      />
                      <RadioButton
                        value="3"
                        label="Lucro Presumido"
                        aria-label='Lucro Presumido'
                      />
                      <RadioButton
                        value="4"
                        label="Simples Nacional"
                        aria-label='Simples Nacional'

                      />                  
                    </RadioButtonGroup>
                    {
                      this.errorField.tipoTributacao.length > 0 ? (
                    <p className="error_radiobutton">{this.errorField.tipoTributacao}</p>
                      ) : ('')
                    }
                  </Col>
                </Row>
           </fieldset> 
            {/**EMPRESA CONTRATANTE   */}
            <fieldset style={Styles.fieldset}>
                  <legend style={Styles.legenda_filedset}>
                    EMPRESA CONTRATANTE
                </legend>
                <p className="form_p_title2">Campos marcados com <div style={{display: 'contents',color: '#8A0000', fontWeight: 'bold', fontSize: '18px'}}>*</div> são obrigatórios</p>
                <Row>
                  <Col id="i_cnpj" xs="12" sm="12" md="3" lg="3">   
                    <TextField
                      //hintText="CNPJ"   
                      label="CNPJ"
                      id="id_cnpj"
                      floatingLabelText={this.requiredFields.cnpj == true ? ("CNPJ*") : ("CNPJ")}
                      floatingLabelStyle={this.styles.floatingLabelStyle}
                      className="input_style required"
                      errorText={this.errorField.cnpj}
                    >
                      <InputMask
                        mask="99999999/9999-99"
                        maskChar=" "
                        type="tel"
                        name="cnpj"
                        value={this.state.cnpj}
                        onChange={this.handleChange.bind(this)}
                        onBlur={this.validateCnpj.bind(this)}
                      />
                    </TextField>
                  </Col>
                  <Col id="i_openingDate" xs="12" sm="12" md="3" lg="3">
                    <TextField
                      id="id_data_abertura"
                    // hintText="DATA DE ABERTURA"
                      label="DATA DE ABERTURA"
                      floatingLabelText={this.requiredFields.openingDate == true ? ("DATA DE ABERTURA") : ("DATA DE ABERTURA")}
                      className="input_style required"
                      floatingLabelStyle={this.styles.floatingLabelStyle}
                      errorText={this.errorField.openingDate}
                    >
                      <InputMask
                        mask="99/99/9999"
                        maskChar=" "
                        type="tel"
                        name="openingDate"
                        value={this.state.openingDate}
                        onChange={this.handleChange.bind(this)}
                      />
                    </TextField>
                  </Col>
                  <Col id="i_fantasyName" xs="12" sm="12" md="6" lg="6">
                    <TextField
                      //hintText="NOME FANTASIA"
                      label="NOME FANTASIA"
                      floatingLabelText={this.requiredFields.openingDate == true ? ("NOME FANTASIA") : ("NOME FANTASIA")}
                      name="fantasyName"
                      className="input_style required"
                      floatingLabelStyle={this.styles.floatingLabelStyle}
                      errorText={this.errorField.fantasyName}
                      value={this.state.fantasyName}
                      onChange={this.handleChange.bind(this)}
                      onBlur={this.handleChange.bind(this)}
                    />
                  </Col>
                </Row>

                <Row>
                  <Col id="i_businessName" xs="12" sm="12" md="12" lg="12">
                    <TextField
                      //hintText="NOME EMPRESARIAL"
                      label="NOME EMPRESARIAL"
                      floatingLabelText={this.requiredFields.businessName == true ? ("RAZÃO SOCIAL") : ("RAZÃO SOCIAL")}
                      name="businessName"
                      className="input_style required"
                      floatingLabelStyle={this.styles.floatingLabelStyle}                 
                      errorText={this.errorField.businessName}
                      value={this.state.businessName}
                      onChange={this.handleChange.bind(this)}
                      onBlur={this.handleChange.bind(this)}
                    />
                  </Col>
                </Row>

                <Row>
                  <Col id="i_cep" xs="12" sm="12" md="2" lg="2">
                    <TextField
                    // hintText="CEP"
                      label="CEP"
                      floatingLabelText={this.requiredFields.cep == true ? ("CEP") : ("CEP")}
                      className="input_style required"
                      floatingLabelStyle={this.styles.floatingLabelStyle}
                      errorText={this.errorField.cep}
                    >
                      <InputMask
                        mask="99.999-999"
                        maskChar=" "
                        name="cep"
                        type="tel"
                        value={this.state.cep}
                        onChange={this.handleChange.bind(this)}
                      />
                    </TextField>
                    <div id="loading_address" className="spin_finder">
                      <i style={{marginRight: 5}}className="fa fa-spinner fa-spin">{""}</i>
                      Buscando endereço
                    </div>
                  </Col>
                  <Col id="i_addressType" xs="12" sm="12" md="3" lg="3">
                    <SelectField
                      label="LOGRADOURO"
                      //hintText="LOGRADOURO"
                      floatingLabelText={this.requiredFields.addressType == true ? ("LOGRADOURO") : ("LOGRADOURO")}
                      className="input_style required"
                      floatingLabelStyle={this.styles.floatingLabelStyle}
                      name="addressType"
                      errorText={this.errorField.addressType}
                      value={this.state.addressType}
                      onChange={this.handleChangeSelectField.bind(this,"addressType")}
                    >
                      <MenuItem value={"NULL"} label="Não Selecionado" primaryText="Não Selecionado"/>
                      {this.state.addressTypeList.map(item =>
                        <MenuItem key={item.Id} value={item.Id} label={item.Nome}  primaryText={item.Nome} />
                      )}
                    </SelectField>
                  </Col>
                  <Col id="i_address" xs="12" sm="12" md="5" lg="5">
                    <TextField
                      //hintText="ENDEREÇO"
                      label="ENDEREÇO"
                      floatingLabelText={this.requiredFields.address == true ? ("ENDEREÇO") : ("ENDEREÇO")}
                      name="address"
                      floatingLabelStyle={this.styles.floatingLabelStyle}
                      className="input_style required"
                      errorText={this.errorField.address}
                      value={this.state.address}
                      onChange={this.handleChange.bind(this)}
                    />
                  </Col>
                  <Col id="i_addressNumber" xs="12" sm="12" md="2" lg="2">
                    <TextField
                      //hintText="NÚMERO"
                      floatingLabelText={this.requiredFields.addressNumber == true ? ("NÚMERO") : ("NÚMERO")}
                      className="input_style required"
                      floatingLabelStyle={this.styles.floatingLabelStyle}
                      errorText={this.errorField.addressNumber}
                    >
                      <CurrencyInput
                        id="addressNumber"
                        label="NÚMERO"
                        precision="0"
                        name="addressNumber"
                        decimalSeparator=""
                        thousandSeparator=""
                        value={this.state.addressNumber}
                        onChangeEvent={this.handleChange.bind(this)}
                        prefix=""
                      />
                    </TextField>
                  </Col>
                </Row>

                <Row>
                  <Col id="i_addressComplement" xs="12" sm="12" md="3" lg="3">
                    <TextField
                      //hintText="COMPLEMENTO"
                      label="COMPLEMENTO"
                      floatingLabelText={this.requiredFields.addressComplement == true ? ("COMPLEMENTO") : ("COMPLEMENTO")}
                      name="addressComplement"
                      className="input_style"
                      floatingLabelStyle={this.styles.floatingLabelStyle}
                      errorText={this.errorField.addressComplement}
                      value={this.state.addressComplement}
                      onChange={this.handleChange.bind(this)}
                    />
                  </Col>
                  <Col id="i_state" xs="12" sm="12" md="2" lg="2">
                    <SelectField
                      //hintText="UF"
                      label="UF"
                      floatingLabelText={this.requiredFields.state == true ? ("UF") : ("UF")}
                      className="input_style required"
                      floatingLabelStyle={this.styles.floatingLabelStyle}
                      name="state"
                      errorText={this.errorField.state}
                      value={this.state.state}
                      onChange={this.handleChangeSelectField.bind(this, 'state')}
                    >
                      <MenuItem value={"NULL"} label="Não Selecionado" primaryText="Não Selecionado"/>
                      {this.state.stateList.map(item =>
                        <MenuItem key={item.Id} value={item.Id} label={item.Sigla}  primaryText={item.Sigla} />
                      )}
                    </SelectField>
                  </Col>
                  <Col id="i_city" xs="12" sm="12" md="4" lg="4">
                    <SelectField
                      //hintText="CIDADE"
                      label="CIDADE"
                      floatingLabelText={this.requiredFields.city == true ? ("CIDADE") : ("CIDADE")}
                      className="input_style required"
                      floatingLabelStyle={this.styles.floatingLabelStyle}
                      name="city"
                      errorText={this.errorField.city}
                      value={this.state.city}
                      onChange={this.handleChangeSelectField.bind(this,"city")}
                    >
                      <MenuItem value={"NULL"} label="Não Selecionado" primaryText="Não Selecionado"/>
                      {this.state.cityList.map(item =>
                        <MenuItem key={item.Id} value={item.Id} label={item.Nome}  primaryText={item.Nome} />
                      )}
                    </SelectField>
                  </Col>
                  <Col id="i_district" xs="12" sm="12" md="3" lg="3">
                    <SelectField
                      //hintText="BAIRRO"
                      label="BAIRRO"
                      iconStyle={{ ariaLabel: "Abrir lista de bairros" }}
                      floatingLabelText={this.requiredFields.district == true ? ("BAIRRO") : ("BAIRRO")}
                      className="input_style required"
                      floatingLabelStyle={this.styles.floatingLabelStyle}
                      name="district"
                      errorText={this.errorField.district}
                      value={this.state.district}
                      onChange={this.handleChangeSelectField.bind(this,"district")}
                    >
                      <MenuItem value={"NULL"} label="Não Selecionado" primaryText="Não Selecionado"/>
                      {this.state.districtList.map(item =>
                        <MenuItem key={item.Id} value={item.Id} label={item.Nome}  primaryText={item.Nome} />
                      )}
                    </SelectField>
                  </Col>
                </Row>

                <Row>
                  <Col id="i_homePhone" xs="12" sm="12" md="4" lg="3">
                    <TextField
                      label="TELEFONE FIXO"
                      //hintText="TELEFONE FIXO"
                      floatingLabelText={this.requiredFields.homePhone == true ? ("TELEFONE FIXO") : ("TELEFONE FIXO")}
                      className="input_style"
                      floatingLabelStyle={this.styles.floatingLabelStyle}
                      errorText={this.errorField.homePhone}
                    >
                      <InputMask
                        mask="(99) 9999-9999"
                        maskChar=" "
                        type="tel"
                        name="homePhone"
                        value={this.state.homePhone}
                        onChange={this.handleChange.bind(this)}
                      />
                    </TextField>
                  </Col>
                  <Col id="i_cellPhone" xs="12" sm="12" md="4" lg="3">
                    <TextField
                      //hintText="CELULAR 1"
                      label="CELULAR 1"
                      floatingLabelStyle={this.styles.floatingLabelStyle}
                      floatingLabelText={this.requiredFields.cellPhone == true ? ("CELULAR 1") : ("CELULAR 1")}
                      className="input_style required"
                      errorText={this.errorField.cellPhone}
                    >
                      <InputMask
                        mask="(99) \9 9999-9999"
                        maskChar=" "
                        type="tel"
                        name="cellPhone"
                        value={this.state.cellPhone}
                        onChange={this.handleChange.bind(this)}
                      />
                    </TextField>
                  </Col>
                  <Col id="i_cellPhone2" xs="12" sm="12" md="4" lg="3">
                    <TextField
                      //hintText="CELULAR 2"
                      label="CELULAR 2"
                      floatingLabelText={this.requiredFields.cellPhone2 == true ? ("CELULAR 2") : ("CELULAR 2")}
                      floatingLabelStyle={this.styles.floatingLabelStyle}                  
                      className="input_style"
                      errorText={this.errorField.cellPhone2}
                      >
                      <InputMask
                        mask="(99) \9 9999-9999"
                        maskChar=" "
                        type="tel"
                        name="cellPhone2"
                        value={this.state.cellPhone2}
                        onChange={this.handleChange.bind(this)}
                      />
                    </TextField>
                  </Col>
                </Row>
            </fieldset>
            {/**RESPONSÁVEL LEGAL */}
            <fieldset style={Styles.fieldset}>
                  <legend style={Styles.legenda_filedset}>
                    RESPONSÁVEL LEGAL DA CONTRATANTE
                </legend> 
                <p className="form_p_title2">(Responsável pela Assinatura do Contrato)</p>

                <Row>
                  <Col id="i_legalResponsible" xs="12" sm="12" md="12" lg="12">
                    <TextField
                    // hintText="NOME COMPLETO"
                      label="NOME COMPLETO"
                      floatingLabelText={this.requiredFields.legalResponsible == true ? ("NOME COMPLETO") : ("NOME COMPLETO")}
                      floatingLabelStyle={this.styles.floatingLabelStyle}
                      name="legalResponsible"
                      className="input_style required"
                      errorText={this.errorField.legalResponsible}
                      value={this.state.legalResponsible}
                      onChange={this.handleChange.bind(this)}
                    />
                  </Col>
                </Row>
                <Row>
                  <Col id="i_legalResponsibleRg" xs="12" sm="12" md="4" lg="3">
                    <TextField
                      //hintText="RG"
                      label="RG"
                      floatingLabelText={this.requiredFields.legalResponsibleRg == true ? ("RG") : ("RG")}
                      name="legalResponsibleRg"
                      floatingLabelStyle={this.styles.floatingLabelStyle}
                      className="input_style required"
                      errorText={this.errorField.legalResponsibleRg}
                      value={this.state.legalResponsibleRg}
                      onChange={this.handleChange.bind(this)}
                    />
                  </Col>
                  <Col id="i_legalResponsibleCpf" xs="12" sm="12" md="4" lg="3">
                    <TextField
                      //hintText="CPF"
                      label="CPF"
                      floatingLabelText={this.requiredFields.legalResponsibleCpf == true ? ("CPF") : ("CPF")}
                      floatingLabelStyle={this.styles.floatingLabelStyle}                  
                      className="input_style required"
                      errorText={this.errorField.legalResponsibleCpf}
                    >
                      <InputMask
                        mask="999.999.999-99"
                        maskChar=" "
                        type="tel"
                        name="legalResponsibleCpf"
                        floatingLabelStyle={this.styles.floatingLabelStyle}
                        value={this.state.legalResponsibleCpf}
                        onChange={this.handleChange.bind(this)}
                      />
                    </TextField>
                  </Col>
                  {/* <Col id="i_legalResponsibleEmail" xs="12" sm="12" md="4" lg="5">
                    <TextField
                      hintText="EMAIL"
                      floatingLabelText={this.requiredFields.legalResponsibleEmail == true ? ("EMAIL *") : ("EMAIL")}
                      name="legalResponsibleEmail"
                      type="email"
                      className="input_style"
                      errorText={this.errorField.legalResponsibleEmail}
                      value={this.state.legalResponsibleEmail}
                      onChange={this.handleChange.bind(this)}
                    />
                  </Col> */}
                </Row>                             
            </fieldset>
            {/** Dialog de Mensagem dos documentos */}
            <Dialog
              modal={true}
              open={this.state.modalErrorImages}
              onRequestClose={this.handleErrorClose.bind(this)}
            >
              <p className="modal_title">AVISO!</p>
              <div className="modal_error_text">
                  <p>
                    Verifique os campos para anexos de documentos. Os campos{' '}
                    {this.state.documentType === 'rg' ? (
                    <span style={{ color: 'red', fontWeight: 'bold' }}>
                      RG, CPF e CNPJ
                    </span>
                    ) : (
                    <span style={{ color: 'red', fontWeight: 'bold' }}>
                      CNH e CNPJ
                    </span>
                    )}
                    {' '}
                    são obrigatórios!
                  </p>
              </div>
              <div style={{ textAlign: "center" }}>                    
                  <Button onClick={this.handleErrorClose.bind(this)} className="modal_button2" >FECHAR</Button>{''}                    
              </div>
            </Dialog>  
            {/** Documentação */}
            <fieldset style={Styles.fieldset}>
                  <legend style={Styles.legenda_filedset}>
                    DOCUMENTAÇÃO
                </legend>
                <Row>
                   {/** Seletor */}
                  <Col md="12" style={{ marginBottom: 20 }}>
                    <label><strong>Selecione o documento de identificação:</strong></label>
                    <div style={{ display: 'flex', gap: '20px' }}>
                      <label>
                        <input 
                          type="radio" 
                          value="rg" 
                          checked={this.state.documentType === 'rg'} 
                          onChange={(e) => this.setState({ documentType: e.target.value })} 
                        /> RG
                      </label>
                      <label>
                        <input 
                          type="radio" 
                          value="cnh" 
                          checked={this.state.documentType === 'cnh'} 
                          onChange={(e) => this.setState({ documentType: e.target.value })} 
                        /> CNH
                      </label>
                    </div>
                  </Col>
                </Row>         
                {/* */}   
                <Row style={{ marginTop: 40 }}>
                  {/* BLOCO 1:  CNH */}
                   {this.state.documentType === 'cnh' && (
                         <Col xs="12" sm="12" md="6" lg="4">
                        <div style={{width:'100%', textAlign:"center"}}>
                          <label htmlFor="doc_cnh" style={{cursor:'pointer'}}>
                            <p className="label_doc_style" style={{textAlign: 'inherit'}}>CNH</p>
                            {this.state.imagesDocs.cnh == "" ? (
                              <div>
                                <div id="name_file_choose_cnh" className="doc_style" style={{minWidth: 290}}>
                                  ESCOLHER O ARQUIVO
                                </div>
                                <p id="legend_doc_style_cnh" className="legend_doc_style">NENHUM ARQUIVO SELECIONADO</p>
                              </div>
                            ):(
                              this.state.imagesDocs.cnh == "pdf" ? (
                                <i id="name_file_pdf_cnh" className="far fa-file-pdf fa-6x icon_layout">{""}</i>
                              ):(
                                <img id="name_file_cnh" src={this.state.imagesDocsUrl.cnh} width="90" className="icon_layout"/>
                              )
                            )}
                          </label>
                          <input id="doc_cnh" style={{visibility:"hidden",position:'absolute',left: -9999}}
                            type="file" name="cnh" onChange={this.fileToBase64.bind(this, 'cnh')}
                          />
                        </div>
                      </Col>
                   )}
                  {/* BLOCO 2: RG VERSO (SÓ APARECE SE FOR RG) */}
                  {this.state.documentType === 'rg' && (
                    [
                      <Col xs="12" sm="12" md="6" lg="4">
                        <div style={{ width: '100%', textAlign: "center" }}>
            
                          <label htmlFor="doc_rg" style={{ cursor: 'pointer' }}>
                            <p className="label_doc_style" style={{ textAlign: 'inherit' }}>RG </p>
                            {this.state.imagesDocs.rg == "" ? (
                              <div>
                                <div id="name_file_choose_rg" className="doc_style" style={{ minWidth: 290 }}>
                                  ESCOLHER O ARQUIVO
                                </div>
                                <p id="legend_doc_style_rg" className="legend_doc_style">NENHUM ARQUIVO SELECIONADO</p>
                              </div>
                            ) : (
                              this.state.imagesDocs.rg == "pdf" ? (
                                <i id="name_file_pdf_rg" className="far fa-file-pdf fa-6x icon_layout">{""}</i>
                              ) : (
                                <img id="name_file_rg" src={this.state.imagesDocsUrl.rg} width="90" className="icon_layout" alt="Preview" />
                              )
                            )}
                          </label>
                          <input id="doc_rg" style={{ visibility: "hidden", position: 'absolute', left: -9999 }}
                            type="file" name="rg" onChange={this.fileToBase64.bind(this, 'rg')}
                          />
                        </div>
                      </Col>,                      
                      <Col xs="12" sm="12" md="6" lg="4">
                        <div style={{ width: '100%', textAlign: "center" }}>
                          <label htmlFor="doc_rg2" style={{ cursor: 'pointer' }}>
                            <p className="label_doc_style" style={{ textAlign: 'inherit' }}>RG (VERSO)</p>
                            {this.state.imagesDocs.rg2 == "" ? (
                              <div>
                                <div id="name_file_choose_rg2" className="doc_style" style={{ minWidth: 290 }}>
                                  ESCOLHER O ARQUIVO
                                </div>
                                <p id="legend_doc_style_rg2" className="legend_doc_style">NENHUM ARQUIVO SELECIONADO</p>
                              </div>
                            ) : (
                              this.state.imagesDocs.rg2 == "pdf" ? (
                                <i id="name_file_pdf_rg2" className="far fa-file-pdf fa-6x icon_layout">{""}</i>
                              ) : (
                                <img id="name_file_rg2" src={this.state.imagesDocsUrl.rg2} width="90" className="icon_layout" alt="Preview" />
                              )
                            )}
                          </label>
                          <input id="doc_rg2" style={{ visibility: "hidden", position: 'absolute', left: -9999 }}
                            type="file" name="rg2" onChange={this.fileToBase64.bind(this, 'rg2')}
                          />
                        </div>
                      </Col>,
                      <Col xs="12" sm="12" md="6" lg="4">
                        {/** CPF  ***********/}
                        <div style={{width:'100%', textAlign:"center"}}>
                          <label htmlFor="doc_cpf" style={{cursor:'pointer'}}>
                            <p className="label_doc_style" style={{textAlign: 'inherit'}}>CPF</p>
                            {this.state.imagesDocs.cpf == "" ? (
                              <div>
                                <div id="name_file_choose_cpf" className="doc_style" style={{minWidth: 290}}>
                                  ESCOLHER O ARQUIVO
                                </div>
                                <p id="legend_doc_style_cpf" className="legend_doc_style">NENHUM ARQUIVO SELECIONADO</p>
                              </div>
                            ):(
                              this.state.imagesDocs.cpf == "pdf" ? (
                                <i id="name_file_pdf_cpf" className="far fa-file-pdf fa-6x icon_layout">{""}</i>
                              ):(
                                <img id="name_file_cpf" src={this.state.imagesDocsUrl.cpf} width="90" className="icon_layout"/>
                              )
                            )}
                          </label>
                          <input id="doc_cpf" style={{visibility:"hidden",position:'absolute',left: -9999}}
                            type="file" name="cpf" onChange={this.fileToBase64.bind(this, 'cpf')}
                          />
                        </div>
                      </Col>
                    ]
                  )}

                  {/* OS DEMAIS DOCUMENTOS (CPF, CNPJ, ENDEREÇO) CONTINUAM ABAIXO... */}

                              <Col xs="12" sm="12" md="6" lg="4">
                                {/** CNPJ  ***********/}
                                <div style={{width:'100%', textAlign:"center"}}>
                                  <label htmlFor="doc_cnpj" style={{cursor:'pointer'}}>
                                    <p className="label_doc_style" style={{textAlign: 'inherit'}}>CNPJ</p>
                                    {this.state.imagesDocs.cnpj == "" ? (
                                      <div>
                                        <div id="name_file_choose_cnpj" className="doc_style" style={{minWidth: 290}}>
                                          ESCOLHER O ARQUIVO
                                        </div>
                                        <p id="legend_doc_style_cnpj" className="legend_doc_style">NENHUM ARQUIVO SELECIONADO</p>
                                      </div>
                                    ):(
                                      this.state.imagesDocs.cnpj == "pdf" ? (
                                        <i id="name_file_pdf_cnpj" className="far fa-file-pdf fa-6x icon_layout">{""}</i>
                                      ):(
                                        <img id="name_file_cnpj" src={this.state.imagesDocsUrl.cnpj} width="90" className="icon_layout"/>
                                      )
                                    )}
                                  </label>
                                  <input id="doc_cnpj" style={{visibility:"hidden",position:'absolute',left: -9999}}
                                    type="file" name="cnpj" onChange={this.fileToBase64.bind(this, 'cnpj')}
                                  />
                                </div>
                              </Col>

                              <Col xs="12" sm="12" md="6" lg="4">
                                {/** COMPROVANTE DE ENDEREÇO (COM CEP)  ***********/}
                                <div style={{width:'100%', textAlign:"center"}}>
                                  <label htmlFor="doc_address" style={{cursor:'pointer'}}>
                                    <p className="label_doc_style" style={{textAlign: 'inherit'}}>COMP. DE ENDEREÇO (COM CEP)</p>
                                    {this.state.imagesDocs.address == "" ? (
                                      <div>
                                        <div id="name_file_choose_address" className="doc_style" style={{minWidth: 290}}>
                                          ESCOLHER O ARQUIVO
                                        </div>
                                        <p id="legend_doc_style_address" className="legend_doc_style">NENHUM ARQUIVO SELECIONADO</p>
                                      </div>
                                    ):(
                                      this.state.imagesDocs.address == "pdf" ? (
                                        <i id="name_file_pdf_address" className="far fa-file-pdf fa-6x icon_layout">{""}</i>
                                      ):(
                                        <img id="name_file_address" src={this.state.imagesDocsUrl.address} width="90" className="icon_layout"/>
                                      )
                                    )}
                                  </label>
                                  <input id="doc_address" style={{visibility:"hidden",position:'absolute',left: -9999}}
                                    type="file" name="address" onChange={this.fileToBase64.bind(this, 'address')}
                                  />
                                </div>
                              </Col>

                              <Col xs="12" sm="12" md="6" lg="4">
                                {/** OUTRO  ***********/}
                                <div style={{width:'100%', textAlign:"center"}}>
                                  <label htmlFor="doc_others" style={{cursor:'pointer'}}>
                                    <p className="label_doc_style" style={{textAlign: 'inherit'}}>CONTRATO</p>
                                    {this.state.imagesDocs.others == "" ? (
                                      <div>
                                        <div id="name_file_choose_others" className="doc_style" style={{minWidth: 290}}>
                                          ESCOLHER O ARQUIVO
                                        </div>
                                        <p id="legend_doc_style_others" className="legend_doc_style">NENHUM ARQUIVO SELECIONADO</p>
                                      </div>
                                    ):(
                                      this.state.imagesDocs.others == "pdf" ? (
                                        <i id="name_file_pdf_others" className="far fa-file-pdf fa-6x icon_layout">{""}</i>
                                      ):(
                                        <img id="name_file_others" src={this.state.imagesDocsUrl.others} width="90" className="icon_layout"/>
                                      )
                                    )}
                                  </label>
                                  <input id="doc_others" style={{visibility:"hidden",position:'absolute',left: -9999}}
                                    type="file" name="others" onChange={this.fileToBase64.bind(this, 'others')}
                                  />
                                </div>
                              </Col>
                </Row> 
            </fieldset>
             {/** Gestão do Contrato */}
            <fieldset style={Styles.fieldset}>
                  <legend style={Styles.legenda_filedset}>
                    GESTÃO DO CONTRATO
                </legend>
            <Row>
              <Col id="i_infoPersonInCharge" xs="12" sm="12" md="8" lg="8">
                <TextField
                  //hintText="ENCARREGADO"
                  floatingLabelText={this.requiredFields.infoPersonInCharge == true ? ("ENCARREGADO *") : ("ENCARREGADO")}
                  floatingLabelStyle={this.styles.floatingLabelStyle}                  
                  name="infoPersonInCharge"
                  type="text"
                  className="input_style"
                  errorText={this.errorField.infoPersonInCharge}
                  value={this.state.infoPersonInCharge}
                  onChange={this.handleChange.bind(this)}
                />
              </Col>
              {/* <Col id="i_infoWorkerName" xs="12" sm="12" md="8" lg="8">
                <TextField
                  hintText="RESPONSÁVEL"
                  floatingLabelText={this.requiredFields.infoWorkerName == true ? ("RESPONSÁVEL *") : ("RESPONSÁVEL")}
                  name="infoWorkerName"
                  type="text"
                  className="input_style"
                  errorText={this.errorField.infoWorkerName}
                  value={this.state.infoWorkerName}
                  onChange={this.handleChange.bind(this)}
                />
                {
                  this.errorField.infoWorkerName.length > 0 ? ('') : (
                <p className="text_tip">
                  Nome do funcionário responsável pela movimentação mensal (inclusão e exclusão)
                </p>
                  )
                }
              </Col> */}
              <Col id="i_infoEmailContact" xs="12" sm="12" md="4" lg="4">
                <TextField
                  //hintText="EMAIL CONTATO"
                  floatingLabelText={this.requiredFields.infoEmailContact == true ? ("EMAIL CONTATO *") : ("EMAIL CONTATO")}
                  name="infoEmailContact"
                  floatingLabelStyle={this.styles.floatingLabelStyle}
                  type="email"
                  className="input_style"
                  errorText={this.errorField.infoEmailContact}
                  value={this.state.infoEmailContact}
                  onChange={this.handleChange.bind(this)}
                />
              </Col>
            </Row>
            <Row>
              <Col id="i_infoHomePhone" xs="12" sm="12" md="3" lg="2">
                <TextField
                  //hintText="TELEFONE FIXO"
                  floatingLabelText={this.requiredFields.infoHomePhone == true ? ("TELEFONE FIXO *") : ("TELEFONE FIXO")}
                  className="input_style"
                  floatingLabelStyle={this.styles.floatingLabelStyle}
                  errorText={this.errorField.infoHomePhone}
                >
                  <InputMask
                    mask="(99) 9999-9999"
                    maskChar=" "
                    type="tel"
                    floatingLabelStyle={this.styles.floatingLabelStyle}
                    name="infoHomePhone"
                    value={this.state.infoHomePhone}
                    onChange={this.handleChange.bind(this)}
                  />
                </TextField>
              </Col>
              <Col id="i_infoCellPhone" xs="12" sm="12" md="3" lg="2">
                <TextField
                  //hintText="CELULAR 1"
                  floatingLabelText={this.requiredFields.infoCellPhone == true ? ("CELULAR *") : ("CELULAR")}
                  className="input_style"
                  floatingLabelStyle={this.styles.floatingLabelStyle}
                  errorText={this.errorField.infoCellPhone}
                >
                  <InputMask
                    mask="(99) \9 9999-9999"
                    maskChar=" "
                    type="tel"
                    name="infoCellPhone"
                    floatingLabelStyle={this.styles.floatingLabelStyle}
                    value={this.state.infoCellPhone}
                    onChange={this.handleChange.bind(this)}
                  />
                </TextField>
              </Col>
              <Col id="i_infoEmailInvoice" xs="12" sm="12" md="6" lg="8">
                <TextField
                  //hintText="EMAIL PARA FATURAS"
                  floatingLabelText={
                    this.requiredFields.infoEmailInvoice == true ? (
                      "EMAIL PARA FATURAS *"
                    ) : (
                      "EMAIL PARA FATURAS"
                    )
                  }
                  name="infoEmailInvoice"
                  type="email"
                  floatingLabelStyle={this.styles.floatingLabelStyle}

                  className="input_style"
                  errorText={this.errorField.infoEmailInvoice}
                  value={this.state.infoEmailInvoice}
                  onChange={this.handleChange.bind(this)}
                />
                {
                  this.errorField.infoEmailInvoice.length > 0 ? ('') : (
                <p className="text_tip">
                  Email para onde serão enviadas as faturas mensais e relação de inscritos no plano
                </p>
                  )
                }
              </Col>
            </Row>
            <Row>
 
            </Row>
            </fieldset>
                <div style={{ marginTop: '30px', display: 'flex', justifyContent: 'flex-end', gap: '10px' }}>
                    <Button
                      color="primary"
                      fullWidth
                      style={{ ...Styles.buttonSuccess, textTransform: 'none', fontWeight: 'bold' }}
                       onClick={this.verifySalesman.bind(this, 2)}
                    >
                    Avançar
                  </Button>                   
                  </div>
          {/*  
            <Row>
              <Col xs="12" sm="12" md="12" lg="12" style={{textAlign:"center"}}>

                         
                <Button
                  onClick={this.verifySalesman.bind(this, 2)}
                  className="button_next_panel"
                >
                  AVANÇAR
                </Button>
               
              </Col>
            </Row>
             */}  
          </Container>
          ) : ('')
        }

        {
          this.state.stepForm == 2 ? (
          <Container className="form_container_internal_panel">
              {/** USUÁRIOS  */}
              <fieldset style={Styles.fieldset}>
                    <legend style={Styles.legenda_filedset}>
                      QUANTIDADE DE USUÁRIOS
                  </legend>
              <Row>
                <Col id="i_amountUsers" xs="12" sm="12" md="12" lg="4" style={{marginBottom: 20}}>
                  <div>
                    <TextField
                    // hintText="CLÍNICO TITULAR"
                      floatingLabelText="CLÍNICO TITULAR"
                      errorText={this.errorField.amountHolder}
                      style={{width: '99%'}}
                      floatingLabelStyle={this.styles.floatingLabelStyle}
                    >
                      <CurrencyInput
                        id="amountHolder"
                        precision="0"
                        decimalSeparator=""
                        thousandSeparator=""
                        aria-label='Clínico Titular'
                        name="amountHolder"
                        value={this.state.amountHolder}
                        onChangeEvent={this.amountUsersChange.bind(this)}
                        prefix=""
                      />
                    </TextField>

                    <TextField
                      //hintText="CLÍNICO DEPENDENTE"
                      floatingLabelText="CLÍNICO DEPENDENTE"
                      errorText={this.errorField.amountDependent}
                      floatingLabelStyle={this.styles.floatingLabelStyle}

                      style={{width: '99%'}}
                    >
                      <CurrencyInput
                        id="amountDependent"
                        precision="0"
                        decimalSeparator=""
                        thousandSeparator=""
                        name="amountDependent"
                        aria-label='Clínico Dependente'
                        value={this.state.amountDependent}
                        onChangeEvent={this.amountUsersChange.bind(this)}
                        prefix=""
                      />
                    </TextField>
                    {
                      this.state.checkPlanOrto == true ? (
                    <TextField
                      hintText="ORTO (TUTULAR/DEPENDENTE)"
                      floatingLabelText="ORTO (TUTULAR/DEPENDENTE)"
                      floatingLabelStyle={this.styles.floatingLabelStyle}

                      errorText={this.errorField.amountOrto}
                      style={{width: '99%'}}
                    >
                      <CurrencyInput
                        id="amountOrto"
                        precision="0"
                        decimalSeparator=""
                        thousandSeparator=""
                        aria-label='Orto Titular/Dependente'
                        name="amountOrto"
                        value={this.state.amountOrto}
                        onChangeEvent={this.amountUsersChange.bind(this)}
                        prefix=""
                      />
                    </TextField>
                      ) : ('')
                    }

              

                    <Checkbox
                      label="INCLUIR PLANO ORTO"
                      style={{marginTop: 25}}
                      aria-label='Incluir Plano Orto'
                      onCheck={this.checkPlanOrtoFn.bind(this)}
                    />
                  </div>
                </Col>

                {
                  this.state.amountUsers.length > 0 ? (
                <Col xs="12" sm="12" md="12" lg="8" style={{marginBottom: 20}}>
                  
                  <Row>
                    
                    <Col xs="12" sm="4" md="4" lg="4" className='top_prices'>
                        <p style={{ marginTop:'22px'}}>PREÇO TABELA</p>
                    </Col>
                    
                    <Col xs="12" sm="8" md="8" lg="8" className='top_prices' >
                      <p className='p_header'>PREÇO NEGOCIÁVEL</p>
                    </Col>

                  </Row>

                  <Row>
                    <Col xs="12" sm="4" md="4" lg="4" className='border_price_1' >
                      <p style={this.styles.amountUsersValueTitle}>R$ POR USUÁRIO</p>
                      <p style={this.styles.amountUsersValueNumber}>{this.state.amountUsersValueShow}</p>
                    </Col>
                    <Col xs="12" sm="8" md="8" lg="8" className='border_price_2'>
                      <Row style={{textAlign: 'center',paddingTop: '14'}}>
                        <Col xs="12" sm="6" md="6" lg="6">
                          <TextField
                            floatingLabelText="TITULAR"
                            style={{textAlign:"left",width: '99%'}}
                            errorText={this.errorField.amountUsersValueHolder}
                          >
                            <CurrencyInput
                              decimalSeparator=","
                              thousandSeparator="."
                              name="amountUsersValueHolder"
                              value={this.state.amountUsersValueHolder}
                              onChangeEvent={this.changeAmountUsersValue.bind(this)}
                              onBlur={this.blurAmountUsersValue.bind(this,null)}
                              prefix="R$ "
                            />
                          </TextField>
                        </Col>
                        <Col xs="12" sm="6" md="6" lg="6">
                          <TextField
                            floatingLabelText="DEPENDENTE" 
                            style={{textAlign:"left",width: '99%'}}
                            errorText={this.errorField.amountUsersValueDependent}
                          >
                            <CurrencyInput
                              decimalSeparator=","
                              thousandSeparator="."
                              name="amountUsersValueDependent"
                              value={this.state.amountUsersValueDependent}
                              onChangeEvent={this.changeAmountUsersValue.bind(this)}
                              onBlur={this.blurAmountUsersValue.bind(this,null)}
                              prefix="R$ "
                            />
                          </TextField>
                        </Col>
                      </Row>
                    </Col>
                  </Row>

                  <Row>
                    {
                      this.state.checkPlanOrto == true ? (
                        <Col xs="12" sm="4" md="4" lg="4" className='border_price_3'>
                        <p style={this.styles.amountUsersValueTitle}>R$ PLANO ORTO (Valor de Referência)</p>
                          <TextField
                            style={{textAlign:"left",width: '50%'}}
                            disabled={true}
                            id="chk_PlanOrtoValue"
                          >
                            <CurrencyInput
                              decimalSeparator=","
                              thousandSeparator="."
                              name="checkPlanOrtoValue"
                              value={this.state.checkPlanOrtoValue}
                              prefix="R$ "
                            />
                          </TextField>   
                        <p style={this.styles.amountUsersValueTitle}>R$ VALOR DO PLANO ORTO</p>
                          <TextField
                            style={{textAlign:"left",width: '50%'}}
                             id="id_valorPlanOrtoFinal"
                          >
                            <CurrencyInput
                              decimalSeparator=","
                              thousandSeparator="."
                              name="valorPlanOrtoFinal"
                              value={this.state.valorPlanOrtoFinal}
                              onChangeEvent={this.changeAmountUsersValue.bind(this)}
                              onBlur={this.blurAmountUsersValue.bind(this,null)}                              
                              prefix="R$ "
                            />
                          </TextField>                                                  
                        </Col>
                      ) : (
                    <Col xs="12" sm="4" md="4" lg="4">{''}</Col>
                      )
                    }

                    {
                      this.state.valuePlanDivergent == true ? (
                    <Col xs="12" sm="8" md="8" lg="8">
                      <p style={this.styles.amountUsersValueHint}>* VALOR DIVERGENTE, JUSTIFIQUE:</p>
                      <TextField
                        multiLine={true}
                        hintText="JUSTIFICATIVA"
                        floatingLabelText="JUSTIFICATIVA *"
                        name="justifyValue"
                        className="input_style"
                        errorText={this.errorField.justifyValue}
                        value={this.state.justifyValue}
                        onChange={this.handleChange.bind(this)}
                      />
                    </Col>
                      ) : (
                    <Col xs="12" sm="8" md="8" lg="8">{''}</Col>
                      )
                    }
                    {
                      this.state.valuePlanOrtoDivergent &&  this.state.checkPlanOrto == true ? (
                    <Col xs="12" sm="8" md="8" lg="8">
                      <p style={{ ...this.styles.amountUsersValueHint, textAlign: 'left' }}>* VALOR DO PLANO ORTO DIVERGENTE, JUSTIFIQUE:</p>
                      <TextField
                        multiLine={true}
                        hintText="JUSTIFICATIVA"
                        floatingLabelText="JUSTIFICATIVA VALOR PLANO ORTO*"
                        name="justifyValueOrto"
                        className="input_style"
                        errorText={this.errorField.justifyValueOrto}
                        value={this.state.justifyValueOrto}
                        onChange={this.handleChange.bind(this)}
                      />
                    </Col>
                      ) : (
                    <Col xs="12" sm="8" md="8" lg="8">{''}</Col>
                      )
                    }
                  </Row>
                </Col>
                  ) : (
                <Col xs="12" sm="12" md="12" lg="8" style={{marginBottom: 20}}>{''}</Col>
                  )
                }
              </Row>

              <Row style={{marginTop: 20, marginBottom: 20}}>
                <Col xs="12" sm="12" md="4" lg="4" style={{textAlign: 'center',marginTop: 20, marginBottom: 20, fontSize: 14}}>
                  <a
                    style={{top: '30%', position: 'relative', color: '#006ADB'}}
                    href="https://planodentalcenter.com.br/assets/docs/PLANILHA_INCLUSAO_FUNCIONARIOS.xlsx"
                  >
                    <i className="fas fa-download fa-2x">{''}</i><br/>
                    BAIXAR PLANILHA MODELO
                  </a>
                </Col>

                <Col id="i_content_file" xs="12" sm="12" md="8" lg="8" style={{marginTop: 20, marginBottom: 20}}>
                  <div style={{width:'100%', textAlign:"center"}}>
                    <label htmlFor="doc_usersTable" style={{cursor:'pointer'}}>
                      <p style={{textAlign: 'center'}} className="label_doc_style">PLANILHA COM RELAÇÃO DE USUÁRIOS</p>
                      {
                        this.state.imagesDocs.usersTable == "" ? (
                      <div>
                        <div id="name_file_choose_usersTable" className="doc_style">ESCOLHER O ARQUIVO</div>
                        <p id="legend_doc_style_usersTable" className="legend_doc_style">NENHUM ARQUIVO SELECIONADO</p>
                      </div>
                      ):(
                        this.state.imagesDocs.usersTable == "xlsx" ? (
                      <div>
                        <i id="name_file_pdf_usersTable" className="far fa-file-excel fa-6x icon_layout">{""}</i>
                        <p style={{fontSize: 12, color: 'rgb(100, 123, 234)'}}>
                          ANEXADO COM SUCESSO!
                        </p>
                      </div>
                        ):(
                          this.state.imagesDocs.usersTable == "error" ? (
                      <div>
                        <div id="name_file_choose_usersTable" className="doc_style">ESCOLHER O ARQUIVO</div>
                        <p id="i_error_plan" style={{fontSize: 12, color: '#ed4134'}}>{this.state.usersTableError}</p>
                      </div>
                          ) : (
                      <div>
                        <div id="name_file_choose_usersTable" className="doc_style">ESCOLHER O ARQUIVO</div>
                        <p style={{fontSize: 12, color: '#ed4134'}}>
                        ERRO - FORMATO ACEITO: .XLSX
                        </p>
                      </div>
                          )
                        )
                      )}
                    </label>
                    <input id="doc_usersTable" style={{visibility:"hidden",position:'absolute',left: -9999}}
                      type="file" name="usersTable" onChange={this.fileToBase64.bind(this, 'usersTable')}
                    />
                  </div>
                </Col>
              </Row>
              <Row>
                <Col style={{marginBottom: 20}} xs="12" sm="12" md="12" lg="12">
                  <Table
                    height="100%"
                    fixedHeader={true}
                    fixedFooter={true}
                    selectable={false}
                    multiSelectable={false}
                  >
                    <TableHeader
                      displaySelectAll={false}
                      adjustForCheckbox={false}
                      enableSelectAll={false}
                      style={{backgroundColor: '#a8243e'}}
                    >
                      <TableRow>
                        <TableHeaderColumn className="center_text" style={{color:'#545454',fontWeight:'bold'}}>
                          SERVIÇOS
                        </TableHeaderColumn>
                        <TableHeaderColumn className="center_text" style={{color:'#505050',fontWeight:'bold'}}>
                          DE 03 A 29 USUÁRIOS
                        </TableHeaderColumn>
                        <TableHeaderColumn className="center_text" style={{color:'#505050',fontWeight:'bold'}}>
                          A PARTIR DE 30 USUÁRIOS
                        </TableHeaderColumn>
                      </TableRow>
                    </TableHeader>

                    <TableBody
                      displayRowCheckbox={false}
                      deselectOnClickaway={false}
                      showRowHover={false}
                      stripedRows={false}
                    >
                      <TableRow key={1}>
                        <TableRowColumn className="justify_text" style={{backgroundColor:'#DDD'}}>
                          Consulta de Urgência e Emergência
                        </TableRowColumn>
                        <TableRowColumn className="col_1_style_user center_text">
                          24 Horas
                        </TableRowColumn>
                        <TableRowColumn className="col_2_style_user center_text">
                          24 Horas
                        </TableRowColumn>
                      </TableRow>

                      <TableRow key={2}>
                        <TableRowColumn className="justify_text" style={{backgroundColor:'#DDD'}}>
                          Consulta Inicial, Radiologia, Atendimentos
                          para Prevenção, Odontopedriatria e Dentística Clínica.
                        </TableRowColumn>
                        <TableRowColumn className="col_1_style_user center_text">
                          30 Dias
                        </TableRowColumn>
                        <TableRowColumn className="col_2_style_user center_text">
                          24 Horas
                        </TableRowColumn>
                      </TableRow>

                      <TableRow key={3}>
                        <TableRowColumn className="justify_text" style={{backgroundColor:'#DDD'}}>
                          Procedimentos em Periodontia
                        </TableRowColumn>
                        <TableRowColumn className="col_1_style_user center_text">
                          60 Dias
                        </TableRowColumn>
                        <TableRowColumn className="col_2_style_user center_text">
                          24 Horas
                        </TableRowColumn>
                      </TableRow>

                      <TableRow key={4}>
                        <TableRowColumn className="justify_text" style={{backgroundColor:'#DDD'}}>
                          Endodontia e Cirurgia
                        </TableRowColumn>
                        <TableRowColumn className="col_1_style_user center_text">
                          120 Dias
                        </TableRowColumn>
                        <TableRowColumn className="col_2_style_user center_text">
                          24 Horas
                        </TableRowColumn>
                      </TableRow>
                    </TableBody>
                  </Table>
                </Col>
              </Row>
            </fieldset>
             <fieldset style={Styles.fieldset}>
                    <legend style={Styles.legenda_filedset}>
                      DATAS E PRAZOS
                  </legend>            
            <p className="form_p_title2">Data de Vigência para Vencimento Mensal</p>

            <Row>
              <Col xs="12" sm="12" md="4" lg="4">
                <SelectField
                  id="effectiveDate"
                  //hintText="DIA DA VIGÊNCIA"
                  floatingLabelText="DIA DA VIGÊNCIA *"
                  className="input_style"
                  name="effectiveDate"
                  errorText={this.errorField.effectiveDate}
                  floatingLabelStyle={this.styles.floatingLabelStyle}
                  value={this.state.effectiveDate}
                  onChange={this.handleChangeSelectField.bind(this,"effectiveDate")}
                >
                  <MenuItem value={"NULL"} label="Não Selecionado" primaryText="Não Selecionado"/>
                  <MenuItem value={"01"} label="01" primaryText="01" />
                  <MenuItem value={"02"} label="02" primaryText="02" />
                  <MenuItem value={"03"} label="03" primaryText="03" />
                  <MenuItem value={"04"} label="04" primaryText="04" />
                  <MenuItem value={"05"} label="05" primaryText="05" />
                  <MenuItem value={"06"} label="06" primaryText="06" />
                  <MenuItem value={"07"} label="07" primaryText="07" />
                  <MenuItem value={"08"} label="08" primaryText="08" />
                  <MenuItem value={"09"} label="09" primaryText="09" />
                  <MenuItem value={"10"} label="10" primaryText="10" />
                  <MenuItem value={"11"} label="11" primaryText="11" />
                  <MenuItem value={"12"} label="12" primaryText="12" />
                  <MenuItem value={"13"} label="13" primaryText="13" />
                  <MenuItem value={"14"} label="14" primaryText="14" />
                  <MenuItem value={"15"} label="15" primaryText="15" />
                  <MenuItem value={"16"} label="16" primaryText="16" />
                  <MenuItem value={"17"} label="17" primaryText="17" />
                  <MenuItem value={"18"} label="18" primaryText="18" />
                  <MenuItem value={"19"} label="19" primaryText="19" />
                  <MenuItem value={"20"} label="20" primaryText="20" />
                  <MenuItem value={"21"} label="21" primaryText="21" />
                  <MenuItem value={"22"} label="22" primaryText="22" />
                  <MenuItem value={"23"} label="23" primaryText="23" />
                  <MenuItem value={"24"} label="24" primaryText="24" />
                  <MenuItem value={"25"} label="25" primaryText="25" />
                  <MenuItem value={"26"} label="26" primaryText="26" />
                  <MenuItem value={"27"} label="27" primaryText="27" />
                  <MenuItem value={"28"} label="28" primaryText="28" />
                  <MenuItem value={"29"} label="29" primaryText="29" />
                  <MenuItem value={"30"} label="30" primaryText="30" />
                </SelectField>
              </Col>

              <Col xs="12" sm="12" md="4" lg="4">
                <SelectField
                  id="effectiveDateMonth"
                  //hintText="MÊS"
                  floatingLabelText="MÊS *"
                  floatingLabelStyle={this.styles.floatingLabelStyle}
                  className="input_style"
                  name="effectiveDateMonth"
                  errorText={this.errorField.effectiveDateMonth}
                  value={this.state.effectiveDateMonth}
                  onChange={this.handleChangeSelectField.bind(this,"effectiveDateMonth")}
                >
                  <MenuItem value={"NULL"} label="Não Selecionado" primaryText="Não Selecionado"/>
                  <MenuItem value={"01"} label="Janeiro"  primaryText="Janeiro" />
                  <MenuItem value={"02"} label="Fevereiro" primaryText="Fevereiro" />
                  <MenuItem value={"03"} label="Março" primaryText="Março" />
                  <MenuItem value={"04"} label="Abril" primaryText="Abril" />
                  <MenuItem value={"05"} label="Maio" primaryText="Maio" />
                  <MenuItem value={"06"} label="Junho" primaryText="Junho" />
                  <MenuItem value={"07"} label="Julho" primaryText="Julho" />
                  <MenuItem value={"08"} label="Agosto" primaryText="Agosto" />
                  <MenuItem value={"09"} label="Setembro" primaryText="Setembro" />
                  <MenuItem value={"10"} label="Outubro" primaryText="Outubro" />
                  <MenuItem value={"11"} label="Novembro" primaryText="Novembro" />
                  <MenuItem value={"12"} label="Dezembro" primaryText="Dezembro" />
                </SelectField>
              </Col>

              <Col xs="12" sm="12" md="4" lg="4">
                <SelectField
                  id="effectiveDateYear"
                  //hintText="ANO"
                  floatingLabelText="ANO *"
                  floatingLabelStyle={this.styles.floatingLabelStyle}
                  className="input_style"
                  name="effectiveDateYear"
                  errorText={this.errorField.effectiveDateYear}
                  value={this.state.effectiveDateYear}
                  onChange={this.handleChangeSelectField.bind(this,"effectiveDateYear")}
                >
                  <MenuItem value={"NULL"} label="Não Selecionado" primaryText="Não Selecionado"/>
                  {this.state.effectiveDateYearList.map(item =>
                    <MenuItem key={item} value={item} label={item} primaryText={item} />
                  )}
                </SelectField>
              </Col>
            </Row>

            <Row>
              <Col style={{marginTop: 30, marginBottom: 20}} xs="12" sm="12" md="12" lg="12">
                <Table
                  height="100%"
                  fixedHeader={true}
                  fixedFooter={true}
                  selectable={false}
                  multiSelectable={false}
                  style={{}}
                >
                  <TableHeader
                    displaySelectAll={false}
                    adjustForCheckbox={false}
                    enableSelectAll={false}
                    style={{backgroundColor: '#a8243e'}}
                  >
                    <TableRow>
                      <TableHeaderColumn colSpan="6" className="center_text" style={{color:'#505050',fontWeight:'bold'}}>
                        DATAS PARA MOVIMENTAÇÕES CADASTRAIS
                      </TableHeaderColumn>
                    </TableRow>                    
                  </TableHeader>

                  <TableBody
                    displayRowCheckbox={false}
                    deselectOnClickaway={false}
                    showRowHover={false}
                    stripedRows={false}
                  >
                    <TableRow key={1}>
                      <TableRowColumn style={{backgroundColor:'#DDD',fontWeight: 500}}>
                        Início da Vigência
                      </TableRowColumn>
                      <TableRowColumn className="col_1_style center_text">
                        De 01 a 05
                      </TableRowColumn>
                      <TableRowColumn className="col_2_style center_text">
                        De 06 a 10
                      </TableRowColumn>
                      <TableRowColumn className="col_3_style center_text">
                        De 11 a 15
                      </TableRowColumn>
                      <TableRowColumn className="col_4_style center_text">
                        De 16 a 20
                      </TableRowColumn>
                      <TableRowColumn className="col_5_style center_text">
                        De 21 a 25
                      </TableRowColumn>
                      <TableRowColumn className="col_6_style center_text">
                        De 26 a 30
                      </TableRowColumn>
                    </TableRow>

                    <TableRow key={2}>
                      <TableRowColumn className="justify_text" style={{backgroundColor:'#DDD',fontWeight: 500}}>
                        Vencimento Mensal Escolhido
                      </TableRowColumn>
                      <TableRowColumn className="col_1_style center_text">
                        Todo dia 05
                      </TableRowColumn>
                      <TableRowColumn className="col_2_style center_text">
                        Todo dia 10
                      </TableRowColumn>
                      <TableRowColumn className="col_3_style center_text">
                        Todo dia 15
                      </TableRowColumn>
                      <TableRowColumn className="col_4_style center_text">
                        Todo dia 20
                      </TableRowColumn>
                      <TableRowColumn className="col_5_style center_text">
                        Todo dia 25
                      </TableRowColumn>
                      <TableRowColumn className="col_6_style center_text">
                        Todo dia 30
                      </TableRowColumn>
                    </TableRow>

                    <TableRow key={4}>
                      <TableRowColumn className="justify_text" style={{backgroundColor:'#DDD',fontWeight: 500}}>
                        Último dia para realizar movimentações cadastrais *
                      </TableRowColumn>
                      <TableRowColumn className="col_1_style center_text">
                        14
                      </TableRowColumn>
                      <TableRowColumn className="col_2_style center_text">
                        19
                      </TableRowColumn>
                      <TableRowColumn className="col_3_style center_text">
                        24
                      </TableRowColumn>
                      <TableRowColumn className="col_4_style center_text">
                        27
                      </TableRowColumn>
                      <TableRowColumn className="col_5_style center_text">
                        4
                      </TableRowColumn>
                      <TableRowColumn className="col_6_style center_text">
                        9
                      </TableRowColumn>
                    </TableRow>
                  </TableBody>
                </Table>

                <Row>
                  <Col md='12'>
                        <FormGroup className="margin_terms">
                          <fieldset className="fieldset_accession">
                            <label className="form_radio_accession" ><input id="checkAccession1" className="style_check" type="checkbox" name="checkAccession1"
                              onClick={this.onOpenModalTerms.bind(this)}
                              onBlur={this.validateCheckbox.bind(this, "checkAccession1")} />
                          LI E ACEITO OS <span className="red_text">TERMOS DE CONTRATAÇÃO</span>
                              <Alert id="alert_checkAccession1">*É necessário aceitar o termo!</Alert>
                            </label>

                          </fieldset>

                        </FormGroup>
                  </Col>                
                </Row>

                    {/************** Modal termo **********/}
                    <Dialog
                      open={this.state.openTerms}
                      onRequestClose={this.onCloseModalTerms}
                      title={
                        <h2 style={{ color: "#696969" }}>TERMOS DE CONTRATAÇÃO</h2>
                      }
                      autoScrollBodyContent={true}
                      actions={
                        <Button className="button_modal2"
                          onClick={this.onCloseModalTerms.bind(this)}>
                          Confirmar
                        </Button>
                      }
                    >
                      <iframe src="../../assets/docs/ContratoPF.pdf?v=2.0" style={{ minHeight: "500px", height: '100%', width: "100%" }}>
                        &nbsp;
                      </iframe>
                    </Dialog>    

                <p style={{marginTop: 15, textAlign: "center"}} className="form_p_title2">
                  (*) Após este prazo qualquer movimentação de usuários somente será aceita no mês seguinte.
                </p>
              </Col>
            </Row>
            </fieldset>
                <div style={{ marginTop: '30px', display: 'flex', justifyContent: 'flex-end', gap: '10px' }}>
                    <Button
                        color="primary"
                        fullWidth
                        style={{
                            ...Styles.buttonCancel,
                            backgroundColor: Colors.textLight,
                            textTransform: 'none'
                        }}
                      onClick={this.verifySalesman.bind(this, 1)}
                      >
                      Voltar
                    </Button>                 
                    <Button
                        color="primary"
                        fullWidth
                        style={{ ...Styles.buttonSuccess, textTransform: 'none', fontWeight: 'bold' }}
                        onClick={this.beforeSubmitForm.bind(this)}
                      >
                      Finalizar
                    </Button>                   
                </div>

          </Container>
          ) : ('')
        }

        {
          this.state.stepForm == 3 ? (
          <Container className="form_container_internal_panel">
            <div style={{textAlign:"center", marginTop:25}}>
              <CircularProgress />
              <p>Enviando...</p>
            </div>
          </Container>
          ) : ('')
        }

{this.state.stepForm === 4 ? (
  <Container className="form_container_internal_panel">
    <div style={{ textAlign: "center", padding: "40px 20px" }}>
      {/* Ícone de Sucesso */}
      <div style={{ marginBottom: 20 }}>
        <i 
          className="fas fa-check-circle" 
          style={{ fontSize: "64px", color: "#4CAF50" }} 
        />
      </div>

      {/* Título Principal */}
      <h2 style={{ color: "#2E7D32", marginBottom: 10, fontWeight: "600" }}>
        Empresa Cadastrada com Sucesso!
      </h2>

      {/* Subtítulo / Descrição */}
      <p style={{ color: "#666", fontSize: "16px", marginBottom: 30 }}>
        Os dados e documentos da empresa foram gravados no sistema.
        {this.state.chanelConfirm === 'EMAIL' && (
          <span> Um e-mail de confirmação foi enviado para o responsável.</span>
        )}
      </p>

      {/* Botões de Navegação */}
      <div style={{ display: "flex", justifyContent: "center", gap: "15px" }}>
      {/* 
        <button
          type="button"
          className="btn btn-primary"
          onClick={() => this.setState({ stepForm: 1 })}
          style={{ padding: "10px 20px", cursor: "pointer" }}
        >
          Cadastrar Outra Empresa
        </button>
        */}
          <Link
            to={urlBase.client + 'panel/companylist/pjawaitingpayment'}
            style={{
              backgroundColor: "#2E7D32",
              borderColor: "#2E7D32",
              color: "#FFF",
              padding: "10px 24px",
              fontSize: "15px",
              fontWeight: "bold",
              borderRadius: "4px",
              cursor: "pointer"
            }}            
          >

          Ir para Lista de Empresas (Aguardando Confirmação)
        </Link>       
      </div>
    </div>
  </Container>
) : null}

        {
          this.state.stepForm == 5 ? (
          <Container className="form_container_internal_panel">
            <div style={{textAlign:"center", marginTop:25}}>
              <p>Ocorreu um problema ao salvar a empresa</p>
              <Button
                  onClick={this.verifySalesman.bind(this, 1)}
                  className="button_back_panel"
                >
                  VOLTAR
              </Button>
            </div>
          </Container>
          ) : ('')
        }

        </Container>
      </div>
    );

  }

}

export default RegisterCompany;



/** WEBPACK FOOTER **
 ** ./src/components/Panel/RegisterCompany/RegisterCompany.js
 **/